(function(global, factory) {
  typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, global.Fuse = factory());
})(this, function() {
  "use strict";
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
      return typeof obj2;
    } : function(obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    Object.defineProperty(subClass, "prototype", {
      value: Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      }),
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf(o);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _assertThisInitialized(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _possibleConstructorReturn(self2, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self2);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function isArray(value) {
    return !Array.isArray ? getTag(value) === "[object Array]" : Array.isArray(value);
  }
  var INFINITY = 1 / 0;
  function baseToString(value) {
    if (typeof value == "string") {
      return value;
    }
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
  }
  function toString(value) {
    return value == null ? "" : baseToString(value);
  }
  function isString(value) {
    return typeof value === "string";
  }
  function isNumber(value) {
    return typeof value === "number";
  }
  function isBoolean(value) {
    return value === true || value === false || isObjectLike(value) && getTag(value) == "[object Boolean]";
  }
  function isObject(value) {
    return _typeof(value) === "object";
  }
  function isObjectLike(value) {
    return isObject(value) && value !== null;
  }
  function isDefined(value) {
    return value !== void 0 && value !== null;
  }
  function isBlank(value) {
    return !value.trim().length;
  }
  function getTag(value) {
    return value == null ? value === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
  }
  var EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
  var INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
  var LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = function LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY2(key) {
    return "Invalid value for key ".concat(key);
  };
  var PATTERN_LENGTH_TOO_LARGE = function PATTERN_LENGTH_TOO_LARGE2(max) {
    return "Pattern length exceeds max of ".concat(max, ".");
  };
  var MISSING_KEY_PROPERTY = function MISSING_KEY_PROPERTY2(name) {
    return "Missing ".concat(name, " property in key");
  };
  var INVALID_KEY_WEIGHT_VALUE = function INVALID_KEY_WEIGHT_VALUE2(key) {
    return "Property 'weight' in key '".concat(key, "' must be a positive integer");
  };
  var hasOwn = Object.prototype.hasOwnProperty;
  var KeyStore = /* @__PURE__ */ function() {
    function KeyStore2(keys) {
      var _this = this;
      _classCallCheck(this, KeyStore2);
      this._keys = [];
      this._keyMap = {};
      var totalWeight = 0;
      keys.forEach(function(key) {
        var obj = createKey(key);
        totalWeight += obj.weight;
        _this._keys.push(obj);
        _this._keyMap[obj.id] = obj;
        totalWeight += obj.weight;
      });
      this._keys.forEach(function(key) {
        key.weight /= totalWeight;
      });
    }
    _createClass(KeyStore2, [{
      key: "get",
      value: function get2(keyId) {
        return this._keyMap[keyId];
      }
    }, {
      key: "keys",
      value: function keys() {
        return this._keys;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        return JSON.stringify(this._keys);
      }
    }]);
    return KeyStore2;
  }();
  function createKey(key) {
    var path = null;
    var id = null;
    var src = null;
    var weight = 1;
    var getFn = null;
    if (isString(key) || isArray(key)) {
      src = key;
      path = createKeyPath(key);
      id = createKeyId(key);
    } else {
      if (!hasOwn.call(key, "name")) {
        throw new Error(MISSING_KEY_PROPERTY("name"));
      }
      var name = key.name;
      src = name;
      if (hasOwn.call(key, "weight")) {
        weight = key.weight;
        if (weight <= 0) {
          throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
        }
      }
      path = createKeyPath(name);
      id = createKeyId(name);
      getFn = key.getFn;
    }
    return {
      path,
      id,
      weight,
      src,
      getFn
    };
  }
  function createKeyPath(key) {
    return isArray(key) ? key : key.split(".");
  }
  function createKeyId(key) {
    return isArray(key) ? key.join(".") : key;
  }
  function get(obj, path) {
    var list = [];
    var arr = false;
    var deepGet = function deepGet2(obj2, path2, index2) {
      if (!isDefined(obj2)) {
        return;
      }
      if (!path2[index2]) {
        list.push(obj2);
      } else {
        var key = path2[index2];
        var value = obj2[key];
        if (!isDefined(value)) {
          return;
        }
        if (index2 === path2.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) {
          list.push(toString(value));
        } else if (isArray(value)) {
          arr = true;
          for (var i = 0, len = value.length; i < len; i += 1) {
            deepGet2(value[i], path2, index2 + 1);
          }
        } else if (path2.length) {
          deepGet2(value, path2, index2 + 1);
        }
      }
    };
    deepGet(obj, isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
  }
  var MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
  };
  var BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: function sortFn(a, b) {
      return a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1;
    }
  };
  var FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
  };
  var AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
  };
  var Config = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, BasicOptions), MatchOptions), FuzzyOptions), AdvancedOptions);
  var SPACE = /[^ ]+/g;
  function norm() {
    var weight = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    var mantissa = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    var cache = /* @__PURE__ */ new Map();
    var m = Math.pow(10, mantissa);
    return {
      get: function get2(value) {
        var numTokens = value.match(SPACE).length;
        if (cache.has(numTokens)) {
          return cache.get(numTokens);
        }
        var norm2 = 1 / Math.pow(numTokens, 0.5 * weight);
        var n = parseFloat(Math.round(norm2 * m) / m);
        cache.set(numTokens, n);
        return n;
      },
      clear: function clear() {
        cache.clear();
      }
    };
  }
  var FuseIndex = /* @__PURE__ */ function() {
    function FuseIndex2() {
      var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref$getFn = _ref.getFn, getFn = _ref$getFn === void 0 ? Config.getFn : _ref$getFn, _ref$fieldNormWeight = _ref.fieldNormWeight, fieldNormWeight = _ref$fieldNormWeight === void 0 ? Config.fieldNormWeight : _ref$fieldNormWeight;
      _classCallCheck(this, FuseIndex2);
      this.norm = norm(fieldNormWeight, 3);
      this.getFn = getFn;
      this.isCreated = false;
      this.setIndexRecords();
    }
    _createClass(FuseIndex2, [{
      key: "setSources",
      value: function setSources() {
        var docs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        this.docs = docs;
      }
    }, {
      key: "setIndexRecords",
      value: function setIndexRecords() {
        var records = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        this.records = records;
      }
    }, {
      key: "setKeys",
      value: function setKeys() {
        var _this = this;
        var keys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        this.keys = keys;
        this._keysMap = {};
        keys.forEach(function(key, idx) {
          _this._keysMap[key.id] = idx;
        });
      }
    }, {
      key: "create",
      value: function create() {
        var _this2 = this;
        if (this.isCreated || !this.docs.length) {
          return;
        }
        this.isCreated = true;
        if (isString(this.docs[0])) {
          this.docs.forEach(function(doc, docIndex) {
            _this2._addString(doc, docIndex);
          });
        } else {
          this.docs.forEach(function(doc, docIndex) {
            _this2._addObject(doc, docIndex);
          });
        }
        this.norm.clear();
      }
      // Adds a doc to the end of the index
    }, {
      key: "add",
      value: function add(doc) {
        var idx = this.size();
        if (isString(doc)) {
          this._addString(doc, idx);
        } else {
          this._addObject(doc, idx);
        }
      }
      // Removes the doc at the specified index of the index
    }, {
      key: "removeAt",
      value: function removeAt(idx) {
        this.records.splice(idx, 1);
        for (var i = idx, len = this.size(); i < len; i += 1) {
          this.records[i].i -= 1;
        }
      }
    }, {
      key: "getValueForItemAtKeyId",
      value: function getValueForItemAtKeyId(item2, keyId) {
        return item2[this._keysMap[keyId]];
      }
    }, {
      key: "size",
      value: function size() {
        return this.records.length;
      }
    }, {
      key: "_addString",
      value: function _addString(doc, docIndex) {
        if (!isDefined(doc) || isBlank(doc)) {
          return;
        }
        var record = {
          v: doc,
          i: docIndex,
          n: this.norm.get(doc)
        };
        this.records.push(record);
      }
    }, {
      key: "_addObject",
      value: function _addObject(doc, docIndex) {
        var _this3 = this;
        var record = {
          i: docIndex,
          $: {}
        };
        this.keys.forEach(function(key, keyIndex) {
          var value = key.getFn ? key.getFn(doc) : _this3.getFn(doc, key.path);
          if (!isDefined(value)) {
            return;
          }
          if (isArray(value)) {
            (function() {
              var subRecords = [];
              var stack = [{
                nestedArrIndex: -1,
                value
              }];
              while (stack.length) {
                var _stack$pop = stack.pop(), nestedArrIndex = _stack$pop.nestedArrIndex, _value = _stack$pop.value;
                if (!isDefined(_value)) {
                  continue;
                }
                if (isString(_value) && !isBlank(_value)) {
                  var subRecord2 = {
                    v: _value,
                    i: nestedArrIndex,
                    n: _this3.norm.get(_value)
                  };
                  subRecords.push(subRecord2);
                } else if (isArray(_value)) {
                  _value.forEach(function(item2, k) {
                    stack.push({
                      nestedArrIndex: k,
                      value: item2
                    });
                  });
                } else ;
              }
              record.$[keyIndex] = subRecords;
            })();
          } else if (isString(value) && !isBlank(value)) {
            var subRecord = {
              v: value,
              n: _this3.norm.get(value)
            };
            record.$[keyIndex] = subRecord;
          }
        });
        this.records.push(record);
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        return {
          keys: this.keys,
          records: this.records
        };
      }
    }]);
    return FuseIndex2;
  }();
  function createIndex(keys, docs) {
    var _ref2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref2$getFn = _ref2.getFn, getFn = _ref2$getFn === void 0 ? Config.getFn : _ref2$getFn, _ref2$fieldNormWeight = _ref2.fieldNormWeight, fieldNormWeight = _ref2$fieldNormWeight === void 0 ? Config.fieldNormWeight : _ref2$fieldNormWeight;
    var myIndex = new FuseIndex({
      getFn,
      fieldNormWeight
    });
    myIndex.setKeys(keys.map(createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
  }
  function parseIndex(data) {
    var _ref3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref3$getFn = _ref3.getFn, getFn = _ref3$getFn === void 0 ? Config.getFn : _ref3$getFn, _ref3$fieldNormWeight = _ref3.fieldNormWeight, fieldNormWeight = _ref3$fieldNormWeight === void 0 ? Config.fieldNormWeight : _ref3$fieldNormWeight;
    var keys = data.keys, records = data.records;
    var myIndex = new FuseIndex({
      getFn,
      fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
  }
  function computeScore$1(pattern) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref$errors = _ref.errors, errors = _ref$errors === void 0 ? 0 : _ref$errors, _ref$currentLocation = _ref.currentLocation, currentLocation = _ref$currentLocation === void 0 ? 0 : _ref$currentLocation, _ref$expectedLocation = _ref.expectedLocation, expectedLocation = _ref$expectedLocation === void 0 ? 0 : _ref$expectedLocation, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? Config.distance : _ref$distance, _ref$ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;
    var accuracy = errors / pattern.length;
    if (ignoreLocation) {
      return accuracy;
    }
    var proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) {
      return proximity ? 1 : accuracy;
    }
    return accuracy + proximity / distance;
  }
  function convertMaskToIndices() {
    var matchmask = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var minMatchCharLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Config.minMatchCharLength;
    var indices = [];
    var start = -1;
    var end = -1;
    var i = 0;
    for (var len = matchmask.length; i < len; i += 1) {
      var match = matchmask[i];
      if (match && start === -1) {
        start = i;
      } else if (!match && start !== -1) {
        end = i - 1;
        if (end - start + 1 >= minMatchCharLength) {
          indices.push([start, end]);
        }
        start = -1;
      }
    }
    if (matchmask[i - 1] && i - start >= minMatchCharLength) {
      indices.push([start, i - 1]);
    }
    return indices;
  }
  var MAX_BITS = 32;
  function search(text, pattern, patternAlphabet) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref$location = _ref.location, location2 = _ref$location === void 0 ? Config.location : _ref$location, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? Config.distance : _ref$distance, _ref$threshold = _ref.threshold, threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold, _ref$findAllMatches = _ref.findAllMatches, findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches, _ref$minMatchCharLeng = _ref.minMatchCharLength, minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng, _ref$includeMatches = _ref.includeMatches, includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches, _ref$ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;
    if (pattern.length > MAX_BITS) {
      throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
    }
    var patternLen = pattern.length;
    var textLen = text.length;
    var expectedLocation = Math.max(0, Math.min(location2, textLen));
    var currentThreshold = threshold;
    var bestLocation = expectedLocation;
    var computeMatches = minMatchCharLength > 1 || includeMatches;
    var matchMask = computeMatches ? Array(textLen) : [];
    var index2;
    while ((index2 = text.indexOf(pattern, bestLocation)) > -1) {
      var score = computeScore$1(pattern, {
        currentLocation: index2,
        expectedLocation,
        distance,
        ignoreLocation
      });
      currentThreshold = Math.min(score, currentThreshold);
      bestLocation = index2 + patternLen;
      if (computeMatches) {
        var i = 0;
        while (i < patternLen) {
          matchMask[index2 + i] = 1;
          i += 1;
        }
      }
    }
    bestLocation = -1;
    var lastBitArr = [];
    var finalScore = 1;
    var binMax = patternLen + textLen;
    var mask = 1 << patternLen - 1;
    for (var _i = 0; _i < patternLen; _i += 1) {
      var binMin = 0;
      var binMid = binMax;
      while (binMin < binMid) {
        var _score2 = computeScore$1(pattern, {
          errors: _i,
          currentLocation: expectedLocation + binMid,
          expectedLocation,
          distance,
          ignoreLocation
        });
        if (_score2 <= currentThreshold) {
          binMin = binMid;
        } else {
          binMax = binMid;
        }
        binMid = Math.floor((binMax - binMin) / 2 + binMin);
      }
      binMax = binMid;
      var start = Math.max(1, expectedLocation - binMid + 1);
      var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
      var bitArr = Array(finish + 2);
      bitArr[finish + 1] = (1 << _i) - 1;
      for (var j = finish; j >= start; j -= 1) {
        var currentLocation = j - 1;
        var charMatch = patternAlphabet[text.charAt(currentLocation)];
        if (computeMatches) {
          matchMask[currentLocation] = +!!charMatch;
        }
        bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
        if (_i) {
          bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
        }
        if (bitArr[j] & mask) {
          finalScore = computeScore$1(pattern, {
            errors: _i,
            currentLocation,
            expectedLocation,
            distance,
            ignoreLocation
          });
          if (finalScore <= currentThreshold) {
            currentThreshold = finalScore;
            bestLocation = currentLocation;
            if (bestLocation <= expectedLocation) {
              break;
            }
            start = Math.max(1, 2 * expectedLocation - bestLocation);
          }
        }
      }
      var _score = computeScore$1(pattern, {
        errors: _i + 1,
        currentLocation: expectedLocation,
        expectedLocation,
        distance,
        ignoreLocation
      });
      if (_score > currentThreshold) {
        break;
      }
      lastBitArr = bitArr;
    }
    var result = {
      isMatch: bestLocation >= 0,
      // Count exact matches (those with a score of 0) to be "almost" exact
      score: Math.max(1e-3, finalScore)
    };
    if (computeMatches) {
      var indices = convertMaskToIndices(matchMask, minMatchCharLength);
      if (!indices.length) {
        result.isMatch = false;
      } else if (includeMatches) {
        result.indices = indices;
      }
    }
    return result;
  }
  function createPatternAlphabet(pattern) {
    var mask = {};
    for (var i = 0, len = pattern.length; i < len; i += 1) {
      var _char = pattern.charAt(i);
      mask[_char] = (mask[_char] || 0) | 1 << len - i - 1;
    }
    return mask;
  }
  var BitapSearch = /* @__PURE__ */ function() {
    function BitapSearch2(pattern) {
      var _this = this;
      var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref$location = _ref.location, location2 = _ref$location === void 0 ? Config.location : _ref$location, _ref$threshold = _ref.threshold, threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? Config.distance : _ref$distance, _ref$includeMatches = _ref.includeMatches, includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches, _ref$findAllMatches = _ref.findAllMatches, findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches, _ref$minMatchCharLeng = _ref.minMatchCharLength, minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng, _ref$isCaseSensitive = _ref.isCaseSensitive, isCaseSensitive = _ref$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref$isCaseSensitive, _ref$ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;
      _classCallCheck(this, BitapSearch2);
      this.options = {
        location: location2,
        threshold,
        distance,
        includeMatches,
        findAllMatches,
        minMatchCharLength,
        isCaseSensitive,
        ignoreLocation
      };
      this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
      this.chunks = [];
      if (!this.pattern.length) {
        return;
      }
      var addChunk = function addChunk2(pattern2, startIndex2) {
        _this.chunks.push({
          pattern: pattern2,
          alphabet: createPatternAlphabet(pattern2),
          startIndex: startIndex2
        });
      };
      var len = this.pattern.length;
      if (len > MAX_BITS) {
        var i = 0;
        var remainder = len % MAX_BITS;
        var end = len - remainder;
        while (i < end) {
          addChunk(this.pattern.substr(i, MAX_BITS), i);
          i += MAX_BITS;
        }
        if (remainder) {
          var startIndex = len - MAX_BITS;
          addChunk(this.pattern.substr(startIndex), startIndex);
        }
      } else {
        addChunk(this.pattern, 0);
      }
    }
    _createClass(BitapSearch2, [{
      key: "searchIn",
      value: function searchIn(text) {
        var _this$options = this.options, isCaseSensitive = _this$options.isCaseSensitive, includeMatches = _this$options.includeMatches;
        if (!isCaseSensitive) {
          text = text.toLowerCase();
        }
        if (this.pattern === text) {
          var _result = {
            isMatch: true,
            score: 0
          };
          if (includeMatches) {
            _result.indices = [[0, text.length - 1]];
          }
          return _result;
        }
        var _this$options2 = this.options, location2 = _this$options2.location, distance = _this$options2.distance, threshold = _this$options2.threshold, findAllMatches = _this$options2.findAllMatches, minMatchCharLength = _this$options2.minMatchCharLength, ignoreLocation = _this$options2.ignoreLocation;
        var allIndices = [];
        var totalScore = 0;
        var hasMatches = false;
        this.chunks.forEach(function(_ref2) {
          var pattern = _ref2.pattern, alphabet = _ref2.alphabet, startIndex = _ref2.startIndex;
          var _search = search(text, pattern, alphabet, {
            location: location2 + startIndex,
            distance,
            threshold,
            findAllMatches,
            minMatchCharLength,
            includeMatches,
            ignoreLocation
          }), isMatch = _search.isMatch, score = _search.score, indices = _search.indices;
          if (isMatch) {
            hasMatches = true;
          }
          totalScore += score;
          if (isMatch && indices) {
            allIndices = [].concat(_toConsumableArray(allIndices), _toConsumableArray(indices));
          }
        });
        var result = {
          isMatch: hasMatches,
          score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) {
          result.indices = allIndices;
        }
        return result;
      }
    }]);
    return BitapSearch2;
  }();
  var BaseMatch = /* @__PURE__ */ function() {
    function BaseMatch2(pattern) {
      _classCallCheck(this, BaseMatch2);
      this.pattern = pattern;
    }
    _createClass(BaseMatch2, [{
      key: "search",
      value: function search2() {
      }
    }], [{
      key: "isMultiMatch",
      value: function isMultiMatch(pattern) {
        return getMatch(pattern, this.multiRegex);
      }
    }, {
      key: "isSingleMatch",
      value: function isSingleMatch(pattern) {
        return getMatch(pattern, this.singleRegex);
      }
    }]);
    return BaseMatch2;
  }();
  function getMatch(pattern, exp) {
    var matches = pattern.match(exp);
    return matches ? matches[1] : null;
  }
  var ExactMatch = /* @__PURE__ */ function(_BaseMatch) {
    _inherits(ExactMatch2, _BaseMatch);
    var _super = _createSuper(ExactMatch2);
    function ExactMatch2(pattern) {
      _classCallCheck(this, ExactMatch2);
      return _super.call(this, pattern);
    }
    _createClass(ExactMatch2, [{
      key: "search",
      value: function search2(text) {
        var isMatch = text === this.pattern;
        return {
          isMatch,
          score: isMatch ? 0 : 1,
          indices: [0, this.pattern.length - 1]
        };
      }
    }], [{
      key: "type",
      get: function get2() {
        return "exact";
      }
    }, {
      key: "multiRegex",
      get: function get2() {
        return /^="(.*)"$/;
      }
    }, {
      key: "singleRegex",
      get: function get2() {
        return /^=(.*)$/;
      }
    }]);
    return ExactMatch2;
  }(BaseMatch);
  var InverseExactMatch = /* @__PURE__ */ function(_BaseMatch) {
    _inherits(InverseExactMatch2, _BaseMatch);
    var _super = _createSuper(InverseExactMatch2);
    function InverseExactMatch2(pattern) {
      _classCallCheck(this, InverseExactMatch2);
      return _super.call(this, pattern);
    }
    _createClass(InverseExactMatch2, [{
      key: "search",
      value: function search2(text) {
        var index2 = text.indexOf(this.pattern);
        var isMatch = index2 === -1;
        return {
          isMatch,
          score: isMatch ? 0 : 1,
          indices: [0, text.length - 1]
        };
      }
    }], [{
      key: "type",
      get: function get2() {
        return "inverse-exact";
      }
    }, {
      key: "multiRegex",
      get: function get2() {
        return /^!"(.*)"$/;
      }
    }, {
      key: "singleRegex",
      get: function get2() {
        return /^!(.*)$/;
      }
    }]);
    return InverseExactMatch2;
  }(BaseMatch);
  var PrefixExactMatch = /* @__PURE__ */ function(_BaseMatch) {
    _inherits(PrefixExactMatch2, _BaseMatch);
    var _super = _createSuper(PrefixExactMatch2);
    function PrefixExactMatch2(pattern) {
      _classCallCheck(this, PrefixExactMatch2);
      return _super.call(this, pattern);
    }
    _createClass(PrefixExactMatch2, [{
      key: "search",
      value: function search2(text) {
        var isMatch = text.startsWith(this.pattern);
        return {
          isMatch,
          score: isMatch ? 0 : 1,
          indices: [0, this.pattern.length - 1]
        };
      }
    }], [{
      key: "type",
      get: function get2() {
        return "prefix-exact";
      }
    }, {
      key: "multiRegex",
      get: function get2() {
        return /^\^"(.*)"$/;
      }
    }, {
      key: "singleRegex",
      get: function get2() {
        return /^\^(.*)$/;
      }
    }]);
    return PrefixExactMatch2;
  }(BaseMatch);
  var InversePrefixExactMatch = /* @__PURE__ */ function(_BaseMatch) {
    _inherits(InversePrefixExactMatch2, _BaseMatch);
    var _super = _createSuper(InversePrefixExactMatch2);
    function InversePrefixExactMatch2(pattern) {
      _classCallCheck(this, InversePrefixExactMatch2);
      return _super.call(this, pattern);
    }
    _createClass(InversePrefixExactMatch2, [{
      key: "search",
      value: function search2(text) {
        var isMatch = !text.startsWith(this.pattern);
        return {
          isMatch,
          score: isMatch ? 0 : 1,
          indices: [0, text.length - 1]
        };
      }
    }], [{
      key: "type",
      get: function get2() {
        return "inverse-prefix-exact";
      }
    }, {
      key: "multiRegex",
      get: function get2() {
        return /^!\^"(.*)"$/;
      }
    }, {
      key: "singleRegex",
      get: function get2() {
        return /^!\^(.*)$/;
      }
    }]);
    return InversePrefixExactMatch2;
  }(BaseMatch);
  var SuffixExactMatch = /* @__PURE__ */ function(_BaseMatch) {
    _inherits(SuffixExactMatch2, _BaseMatch);
    var _super = _createSuper(SuffixExactMatch2);
    function SuffixExactMatch2(pattern) {
      _classCallCheck(this, SuffixExactMatch2);
      return _super.call(this, pattern);
    }
    _createClass(SuffixExactMatch2, [{
      key: "search",
      value: function search2(text) {
        var isMatch = text.endsWith(this.pattern);
        return {
          isMatch,
          score: isMatch ? 0 : 1,
          indices: [text.length - this.pattern.length, text.length - 1]
        };
      }
    }], [{
      key: "type",
      get: function get2() {
        return "suffix-exact";
      }
    }, {
      key: "multiRegex",
      get: function get2() {
        return /^"(.*)"\$$/;
      }
    }, {
      key: "singleRegex",
      get: function get2() {
        return /^(.*)\$$/;
      }
    }]);
    return SuffixExactMatch2;
  }(BaseMatch);
  var InverseSuffixExactMatch = /* @__PURE__ */ function(_BaseMatch) {
    _inherits(InverseSuffixExactMatch2, _BaseMatch);
    var _super = _createSuper(InverseSuffixExactMatch2);
    function InverseSuffixExactMatch2(pattern) {
      _classCallCheck(this, InverseSuffixExactMatch2);
      return _super.call(this, pattern);
    }
    _createClass(InverseSuffixExactMatch2, [{
      key: "search",
      value: function search2(text) {
        var isMatch = !text.endsWith(this.pattern);
        return {
          isMatch,
          score: isMatch ? 0 : 1,
          indices: [0, text.length - 1]
        };
      }
    }], [{
      key: "type",
      get: function get2() {
        return "inverse-suffix-exact";
      }
    }, {
      key: "multiRegex",
      get: function get2() {
        return /^!"(.*)"\$$/;
      }
    }, {
      key: "singleRegex",
      get: function get2() {
        return /^!(.*)\$$/;
      }
    }]);
    return InverseSuffixExactMatch2;
  }(BaseMatch);
  var FuzzyMatch = /* @__PURE__ */ function(_BaseMatch) {
    _inherits(FuzzyMatch2, _BaseMatch);
    var _super = _createSuper(FuzzyMatch2);
    function FuzzyMatch2(pattern) {
      var _this;
      var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref$location = _ref.location, location2 = _ref$location === void 0 ? Config.location : _ref$location, _ref$threshold = _ref.threshold, threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? Config.distance : _ref$distance, _ref$includeMatches = _ref.includeMatches, includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches, _ref$findAllMatches = _ref.findAllMatches, findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches, _ref$minMatchCharLeng = _ref.minMatchCharLength, minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng, _ref$isCaseSensitive = _ref.isCaseSensitive, isCaseSensitive = _ref$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref$isCaseSensitive, _ref$ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation;
      _classCallCheck(this, FuzzyMatch2);
      _this = _super.call(this, pattern);
      _this._bitapSearch = new BitapSearch(pattern, {
        location: location2,
        threshold,
        distance,
        includeMatches,
        findAllMatches,
        minMatchCharLength,
        isCaseSensitive,
        ignoreLocation
      });
      return _this;
    }
    _createClass(FuzzyMatch2, [{
      key: "search",
      value: function search2(text) {
        return this._bitapSearch.searchIn(text);
      }
    }], [{
      key: "type",
      get: function get2() {
        return "fuzzy";
      }
    }, {
      key: "multiRegex",
      get: function get2() {
        return /^"(.*)"$/;
      }
    }, {
      key: "singleRegex",
      get: function get2() {
        return /^(.*)$/;
      }
    }]);
    return FuzzyMatch2;
  }(BaseMatch);
  var IncludeMatch = /* @__PURE__ */ function(_BaseMatch) {
    _inherits(IncludeMatch2, _BaseMatch);
    var _super = _createSuper(IncludeMatch2);
    function IncludeMatch2(pattern) {
      _classCallCheck(this, IncludeMatch2);
      return _super.call(this, pattern);
    }
    _createClass(IncludeMatch2, [{
      key: "search",
      value: function search2(text) {
        var location2 = 0;
        var index2;
        var indices = [];
        var patternLen = this.pattern.length;
        while ((index2 = text.indexOf(this.pattern, location2)) > -1) {
          location2 = index2 + patternLen;
          indices.push([index2, location2 - 1]);
        }
        var isMatch = !!indices.length;
        return {
          isMatch,
          score: isMatch ? 0 : 1,
          indices
        };
      }
    }], [{
      key: "type",
      get: function get2() {
        return "include";
      }
    }, {
      key: "multiRegex",
      get: function get2() {
        return /^'"(.*)"$/;
      }
    }, {
      key: "singleRegex",
      get: function get2() {
        return /^'(.*)$/;
      }
    }]);
    return IncludeMatch2;
  }(BaseMatch);
  var searchers = [ExactMatch, IncludeMatch, PrefixExactMatch, InversePrefixExactMatch, InverseSuffixExactMatch, SuffixExactMatch, InverseExactMatch, FuzzyMatch];
  var searchersLen = searchers.length;
  var SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
  var OR_TOKEN = "|";
  function parseQuery(pattern) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return pattern.split(OR_TOKEN).map(function(item2) {
      var query = item2.trim().split(SPACE_RE).filter(function(item3) {
        return item3 && !!item3.trim();
      });
      var results = [];
      for (var i = 0, len = query.length; i < len; i += 1) {
        var queryItem = query[i];
        var found = false;
        var idx = -1;
        while (!found && ++idx < searchersLen) {
          var searcher = searchers[idx];
          var token = searcher.isMultiMatch(queryItem);
          if (token) {
            results.push(new searcher(token, options));
            found = true;
          }
        }
        if (found) {
          continue;
        }
        idx = -1;
        while (++idx < searchersLen) {
          var _searcher = searchers[idx];
          var _token = _searcher.isSingleMatch(queryItem);
          if (_token) {
            results.push(new _searcher(_token, options));
            break;
          }
        }
      }
      return results;
    });
  }
  var MultiMatchSet = /* @__PURE__ */ new Set([FuzzyMatch.type, IncludeMatch.type]);
  var ExtendedSearch = /* @__PURE__ */ function() {
    function ExtendedSearch2(pattern) {
      var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref$isCaseSensitive = _ref.isCaseSensitive, isCaseSensitive = _ref$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref$isCaseSensitive, _ref$includeMatches = _ref.includeMatches, includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches, _ref$minMatchCharLeng = _ref.minMatchCharLength, minMatchCharLength = _ref$minMatchCharLeng === void 0 ? Config.minMatchCharLength : _ref$minMatchCharLeng, _ref$ignoreLocation = _ref.ignoreLocation, ignoreLocation = _ref$ignoreLocation === void 0 ? Config.ignoreLocation : _ref$ignoreLocation, _ref$findAllMatches = _ref.findAllMatches, findAllMatches = _ref$findAllMatches === void 0 ? Config.findAllMatches : _ref$findAllMatches, _ref$location = _ref.location, location2 = _ref$location === void 0 ? Config.location : _ref$location, _ref$threshold = _ref.threshold, threshold = _ref$threshold === void 0 ? Config.threshold : _ref$threshold, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? Config.distance : _ref$distance;
      _classCallCheck(this, ExtendedSearch2);
      this.query = null;
      this.options = {
        isCaseSensitive,
        includeMatches,
        minMatchCharLength,
        findAllMatches,
        ignoreLocation,
        location: location2,
        threshold,
        distance
      };
      this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
      this.query = parseQuery(this.pattern, this.options);
    }
    _createClass(ExtendedSearch2, [{
      key: "searchIn",
      value: function searchIn(text) {
        var query = this.query;
        if (!query) {
          return {
            isMatch: false,
            score: 1
          };
        }
        var _this$options = this.options, includeMatches = _this$options.includeMatches, isCaseSensitive = _this$options.isCaseSensitive;
        text = isCaseSensitive ? text : text.toLowerCase();
        var numMatches = 0;
        var allIndices = [];
        var totalScore = 0;
        for (var i = 0, qLen = query.length; i < qLen; i += 1) {
          var searchers2 = query[i];
          allIndices.length = 0;
          numMatches = 0;
          for (var j = 0, pLen = searchers2.length; j < pLen; j += 1) {
            var searcher = searchers2[j];
            var _searcher$search = searcher.search(text), isMatch = _searcher$search.isMatch, indices = _searcher$search.indices, score = _searcher$search.score;
            if (isMatch) {
              numMatches += 1;
              totalScore += score;
              if (includeMatches) {
                var type = searcher.constructor.type;
                if (MultiMatchSet.has(type)) {
                  allIndices = [].concat(_toConsumableArray(allIndices), _toConsumableArray(indices));
                } else {
                  allIndices.push(indices);
                }
              }
            } else {
              totalScore = 0;
              numMatches = 0;
              allIndices.length = 0;
              break;
            }
          }
          if (numMatches) {
            var result = {
              isMatch: true,
              score: totalScore / numMatches
            };
            if (includeMatches) {
              result.indices = allIndices;
            }
            return result;
          }
        }
        return {
          isMatch: false,
          score: 1
        };
      }
    }], [{
      key: "condition",
      value: function condition(_, options) {
        return options.useExtendedSearch;
      }
    }]);
    return ExtendedSearch2;
  }();
  var registeredSearchers = [];
  function register() {
    registeredSearchers.push.apply(registeredSearchers, arguments);
  }
  function createSearcher(pattern, options) {
    for (var i = 0, len = registeredSearchers.length; i < len; i += 1) {
      var searcherClass = registeredSearchers[i];
      if (searcherClass.condition(pattern, options)) {
        return new searcherClass(pattern, options);
      }
    }
    return new BitapSearch(pattern, options);
  }
  var LogicalOperator = {
    AND: "$and",
    OR: "$or"
  };
  var KeyType = {
    PATH: "$path",
    PATTERN: "$val"
  };
  var isExpression = function isExpression2(query) {
    return !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
  };
  var isPath = function isPath2(query) {
    return !!query[KeyType.PATH];
  };
  var isLeaf = function isLeaf2(query) {
    return !isArray(query) && isObject(query) && !isExpression(query);
  };
  var convertToExplicit = function convertToExplicit2(query) {
    return _defineProperty({}, LogicalOperator.AND, Object.keys(query).map(function(key) {
      return _defineProperty({}, key, query[key]);
    }));
  };
  function parse(query, options) {
    var _ref3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref3$auto = _ref3.auto, auto = _ref3$auto === void 0 ? true : _ref3$auto;
    var next = function next2(query2) {
      var keys = Object.keys(query2);
      var isQueryPath = isPath(query2);
      if (!isQueryPath && keys.length > 1 && !isExpression(query2)) {
        return next2(convertToExplicit(query2));
      }
      if (isLeaf(query2)) {
        var key = isQueryPath ? query2[KeyType.PATH] : keys[0];
        var pattern = isQueryPath ? query2[KeyType.PATTERN] : query2[key];
        if (!isString(pattern)) {
          throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
        }
        var obj = {
          keyId: createKeyId(key),
          pattern
        };
        if (auto) {
          obj.searcher = createSearcher(pattern, options);
        }
        return obj;
      }
      var node = {
        children: [],
        operator: keys[0]
      };
      keys.forEach(function(key2) {
        var value = query2[key2];
        if (isArray(value)) {
          value.forEach(function(item2) {
            node.children.push(next2(item2));
          });
        }
      });
      return node;
    };
    if (!isExpression(query)) {
      query = convertToExplicit(query);
    }
    return next(query);
  }
  function computeScore(results, _ref) {
    var _ref$ignoreFieldNorm = _ref.ignoreFieldNorm, ignoreFieldNorm = _ref$ignoreFieldNorm === void 0 ? Config.ignoreFieldNorm : _ref$ignoreFieldNorm;
    results.forEach(function(result) {
      var totalScore = 1;
      result.matches.forEach(function(_ref2) {
        var key = _ref2.key, norm2 = _ref2.norm, score = _ref2.score;
        var weight = key ? key.weight : null;
        totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm2));
      });
      result.score = totalScore;
    });
  }
  function transformMatches(result, data) {
    var matches = result.matches;
    data.matches = [];
    if (!isDefined(matches)) {
      return;
    }
    matches.forEach(function(match) {
      if (!isDefined(match.indices) || !match.indices.length) {
        return;
      }
      var indices = match.indices, value = match.value;
      var obj = {
        indices,
        value
      };
      if (match.key) {
        obj.key = match.key.src;
      }
      if (match.idx > -1) {
        obj.refIndex = match.idx;
      }
      data.matches.push(obj);
    });
  }
  function transformScore(result, data) {
    data.score = result.score;
  }
  function format(results, docs) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref$includeMatches = _ref.includeMatches, includeMatches = _ref$includeMatches === void 0 ? Config.includeMatches : _ref$includeMatches, _ref$includeScore = _ref.includeScore, includeScore = _ref$includeScore === void 0 ? Config.includeScore : _ref$includeScore;
    var transformers = [];
    if (includeMatches) transformers.push(transformMatches);
    if (includeScore) transformers.push(transformScore);
    return results.map(function(result) {
      var idx = result.idx;
      var data = {
        item: docs[idx],
        refIndex: idx
      };
      if (transformers.length) {
        transformers.forEach(function(transformer) {
          transformer(result, data);
        });
      }
      return data;
    });
  }
  var Fuse$1 = /* @__PURE__ */ function() {
    function Fuse3(docs) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var index2 = arguments.length > 2 ? arguments[2] : void 0;
      _classCallCheck(this, Fuse3);
      this.options = _objectSpread2(_objectSpread2({}, Config), options);
      if (this.options.useExtendedSearch && false) {
        throw new Error(EXTENDED_SEARCH_UNAVAILABLE);
      }
      this._keyStore = new KeyStore(this.options.keys);
      this.setCollection(docs, index2);
    }
    _createClass(Fuse3, [{
      key: "setCollection",
      value: function setCollection(docs, index2) {
        this._docs = docs;
        if (index2 && !(index2 instanceof FuseIndex)) {
          throw new Error(INCORRECT_INDEX_TYPE);
        }
        this._myIndex = index2 || createIndex(this.options.keys, this._docs, {
          getFn: this.options.getFn,
          fieldNormWeight: this.options.fieldNormWeight
        });
      }
    }, {
      key: "add",
      value: function add(doc) {
        if (!isDefined(doc)) {
          return;
        }
        this._docs.push(doc);
        this._myIndex.add(doc);
      }
    }, {
      key: "remove",
      value: function remove() {
        var predicate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
          return false;
        };
        var results = [];
        for (var i = 0, len = this._docs.length; i < len; i += 1) {
          var doc = this._docs[i];
          if (predicate(doc, i)) {
            this.removeAt(i);
            i -= 1;
            len -= 1;
            results.push(doc);
          }
        }
        return results;
      }
    }, {
      key: "removeAt",
      value: function removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
      }
    }, {
      key: "getIndex",
      value: function getIndex() {
        return this._myIndex;
      }
    }, {
      key: "search",
      value: function search2(query) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? -1 : _ref$limit;
        var _this$options = this.options, includeMatches = _this$options.includeMatches, includeScore = _this$options.includeScore, shouldSort = _this$options.shouldSort, sortFn = _this$options.sortFn, ignoreFieldNorm = _this$options.ignoreFieldNorm;
        var results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        computeScore(results, {
          ignoreFieldNorm
        });
        if (shouldSort) {
          results.sort(sortFn);
        }
        if (isNumber(limit) && limit > -1) {
          results = results.slice(0, limit);
        }
        return format(results, this._docs, {
          includeMatches,
          includeScore
        });
      }
    }, {
      key: "_searchStringList",
      value: function _searchStringList(query) {
        var searcher = createSearcher(query, this.options);
        var records = this._myIndex.records;
        var results = [];
        records.forEach(function(_ref2) {
          var text = _ref2.v, idx = _ref2.i, norm2 = _ref2.n;
          if (!isDefined(text)) {
            return;
          }
          var _searcher$searchIn = searcher.searchIn(text), isMatch = _searcher$searchIn.isMatch, score = _searcher$searchIn.score, indices = _searcher$searchIn.indices;
          if (isMatch) {
            results.push({
              item: text,
              idx,
              matches: [{
                score,
                value: text,
                norm: norm2,
                indices
              }]
            });
          }
        });
        return results;
      }
    }, {
      key: "_searchLogical",
      value: function _searchLogical(query) {
        var _this = this;
        var expression = parse(query, this.options);
        var evaluate = function evaluate2(node, item2, idx) {
          if (!node.children) {
            var keyId = node.keyId, searcher = node.searcher;
            var matches = _this._findMatches({
              key: _this._keyStore.get(keyId),
              value: _this._myIndex.getValueForItemAtKeyId(item2, keyId),
              searcher
            });
            if (matches && matches.length) {
              return [{
                idx,
                item: item2,
                matches
              }];
            }
            return [];
          }
          var res = [];
          for (var i = 0, len = node.children.length; i < len; i += 1) {
            var child = node.children[i];
            var result = evaluate2(child, item2, idx);
            if (result.length) {
              res.push.apply(res, _toConsumableArray(result));
            } else if (node.operator === LogicalOperator.AND) {
              return [];
            }
          }
          return res;
        };
        var records = this._myIndex.records;
        var resultMap = {};
        var results = [];
        records.forEach(function(_ref3) {
          var item2 = _ref3.$, idx = _ref3.i;
          if (isDefined(item2)) {
            var expResults = evaluate(expression, item2, idx);
            if (expResults.length) {
              if (!resultMap[idx]) {
                resultMap[idx] = {
                  idx,
                  item: item2,
                  matches: []
                };
                results.push(resultMap[idx]);
              }
              expResults.forEach(function(_ref4) {
                var _resultMap$idx$matche;
                var matches = _ref4.matches;
                (_resultMap$idx$matche = resultMap[idx].matches).push.apply(_resultMap$idx$matche, _toConsumableArray(matches));
              });
            }
          }
        });
        return results;
      }
    }, {
      key: "_searchObjectList",
      value: function _searchObjectList(query) {
        var _this2 = this;
        var searcher = createSearcher(query, this.options);
        var _this$_myIndex = this._myIndex, keys = _this$_myIndex.keys, records = _this$_myIndex.records;
        var results = [];
        records.forEach(function(_ref5) {
          var item2 = _ref5.$, idx = _ref5.i;
          if (!isDefined(item2)) {
            return;
          }
          var matches = [];
          keys.forEach(function(key, keyIndex) {
            matches.push.apply(matches, _toConsumableArray(_this2._findMatches({
              key,
              value: item2[keyIndex],
              searcher
            })));
          });
          if (matches.length) {
            results.push({
              idx,
              item: item2,
              matches
            });
          }
        });
        return results;
      }
    }, {
      key: "_findMatches",
      value: function _findMatches(_ref6) {
        var key = _ref6.key, value = _ref6.value, searcher = _ref6.searcher;
        if (!isDefined(value)) {
          return [];
        }
        var matches = [];
        if (isArray(value)) {
          value.forEach(function(_ref7) {
            var text2 = _ref7.v, idx = _ref7.i, norm3 = _ref7.n;
            if (!isDefined(text2)) {
              return;
            }
            var _searcher$searchIn2 = searcher.searchIn(text2), isMatch2 = _searcher$searchIn2.isMatch, score2 = _searcher$searchIn2.score, indices2 = _searcher$searchIn2.indices;
            if (isMatch2) {
              matches.push({
                score: score2,
                key,
                value: text2,
                idx,
                norm: norm3,
                indices: indices2
              });
            }
          });
        } else {
          var text = value.v, norm2 = value.n;
          var _searcher$searchIn3 = searcher.searchIn(text), isMatch = _searcher$searchIn3.isMatch, score = _searcher$searchIn3.score, indices = _searcher$searchIn3.indices;
          if (isMatch) {
            matches.push({
              score,
              key,
              value: text,
              norm: norm2,
              indices
            });
          }
        }
        return matches;
      }
    }]);
    return Fuse3;
  }();
  Fuse$1.version = "6.6.2";
  Fuse$1.createIndex = createIndex;
  Fuse$1.parseIndex = parseIndex;
  Fuse$1.config = Config;
  {
    Fuse$1.parseQuery = parse;
  }
  {
    register(ExtendedSearch);
  }
  var Fuse2 = Fuse$1;
  return Fuse2;
});
!function(e, o) {
  if ("function" == typeof define && define.amd) define(["exports"], o);
  else if ("undefined" != typeof exports) o(exports);
  else {
    var t = {};
    o(t), e.bodyScrollLock = t;
  }
}(this, function(exports2) {
  "use strict";
  Object.defineProperty(exports2, "__esModule", { value: true });
  var t = false;
  if ("undefined" != typeof window) {
    var e = { get passive() {
      t = true;
    } };
    window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e);
  }
  function d(o) {
    return s.some(function(e2) {
      return !(!e2.options.allowTouchMove || !e2.options.allowTouchMove(o));
    });
  }
  function l(e2) {
    var o = e2 || window.event;
    return !!d(o.target) || (1 < o.touches.length || (o.preventDefault && o.preventDefault(), false));
  }
  function n() {
    void 0 !== m && (document.body.style.paddingRight = m, m = void 0), void 0 !== v && (document.body.style.overflow = v, v = void 0);
  }
  function i() {
    if (void 0 !== f) {
      var e2 = -parseInt(document.body.style.top, 10), o = -parseInt(document.body.style.left, 10);
      document.body.style.position = f.position, document.body.style.top = f.top, document.body.style.left = f.left, window.scrollTo(o, e2), f = void 0;
    }
  }
  var c = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && 1 < window.navigator.maxTouchPoints), s = [], u = false, a = -1, v = void 0, f = void 0, m = void 0;
  exports2.disableBodyScroll = function(r, e2) {
    if (r) {
      if (!s.some(function(e3) {
        return e3.targetElement === r;
      })) {
        var o = { targetElement: r, options: e2 || {} };
        s = [].concat(function(e3) {
          if (Array.isArray(e3)) {
            for (var o2 = 0, t2 = Array(e3.length); o2 < e3.length; o2++) t2[o2] = e3[o2];
            return t2;
          }
          return Array.from(e3);
        }(s), [o]), c ? window.requestAnimationFrame(function() {
          if (void 0 === f) {
            f = { position: document.body.style.position, top: document.body.style.top, left: document.body.style.left };
            var e3 = window, o2 = e3.scrollY, t2 = e3.scrollX, n2 = e3.innerHeight;
            document.body.style.position = "fixed", document.body.style.top = -o2 + "px", document.body.style.left = -t2 + "px", setTimeout(function() {
              return window.requestAnimationFrame(function() {
                var e4 = n2 - window.innerHeight;
                e4 && n2 <= o2 && (document.body.style.top = -(o2 + e4));
              });
            }, 300);
          }
        }) : function(e3) {
          if (void 0 === m) {
            var o2 = !!e3 && true === e3.reserveScrollBarGap, t2 = window.innerWidth - document.documentElement.clientWidth;
            if (o2 && 0 < t2) {
              var n2 = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
              m = document.body.style.paddingRight, document.body.style.paddingRight = n2 + t2 + "px";
            }
          }
          void 0 === v && (v = document.body.style.overflow, document.body.style.overflow = "hidden");
        }(e2), c && (r.ontouchstart = function(e3) {
          1 === e3.targetTouches.length && (a = e3.targetTouches[0].clientY);
        }, r.ontouchmove = function(e3) {
          var o2, t2, n2, i2;
          1 === e3.targetTouches.length && (t2 = r, i2 = (o2 = e3).targetTouches[0].clientY - a, d(o2.target) || (t2 && 0 === t2.scrollTop && 0 < i2 || (n2 = t2) && n2.scrollHeight - n2.scrollTop <= n2.clientHeight && i2 < 0 ? l(o2) : o2.stopPropagation()));
        }, u || (document.addEventListener("touchmove", l, t ? { passive: false } : void 0), u = true));
      }
    } else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
  }, exports2.clearAllBodyScrollLocks = function() {
    c && (s.forEach(function(e2) {
      e2.targetElement.ontouchstart = null, e2.targetElement.ontouchmove = null;
    }), u && (document.removeEventListener("touchmove", l, t ? { passive: false } : void 0), u = false), a = -1), (c ? i : n)(), s = [];
  }, exports2.enableBodyScroll = function(o) {
    o ? (s = s.filter(function(e2) {
      return e2.targetElement !== o;
    }), c && (o.ontouchstart = null, o.ontouchmove = null, u && 0 === s.length && (document.removeEventListener("touchmove", l, t ? { passive: false } : void 0), u = false)), (c ? i : n)()) : console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
  };
});
function templatePolyfill() {
  if ("content" in document.createElement("template")) {
    return false;
  }
  var templates = document.getElementsByTagName("template");
  var plateLen = templates.length;
  for (var x = 0; x < plateLen; ++x) {
    var template = templates[x];
    var content = template.childNodes;
    var fragment = document.createDocumentFragment();
    while (content[0]) {
      fragment.appendChild(content[0]);
    }
    template.content = fragment;
  }
}
templatePolyfill();
!function(e) {
  var n = false;
  if ("function" == typeof define && define.amd && (define(e), n = true), "object" == typeof exports && (module.exports = e(), n = true), !n) {
    var o = window.Cookies, t = window.Cookies = e();
    t.noConflict = function() {
      return window.Cookies = o, t;
    };
  }
}(function() {
  function e() {
    for (var e2 = 0, n2 = {}; e2 < arguments.length; e2++) {
      var o = arguments[e2];
      for (var t in o) n2[t] = o[t];
    }
    return n2;
  }
  function n(o) {
    function t(n2, r, i) {
      var c;
      if ("undefined" != typeof document) {
        if (arguments.length > 1) {
          if ("number" == typeof (i = e({ path: "/" }, t.defaults, i)).expires) {
            var a = /* @__PURE__ */ new Date();
            a.setMilliseconds(a.getMilliseconds() + 864e5 * i.expires), i.expires = a;
          }
          i.expires = i.expires ? i.expires.toUTCString() : "";
          try {
            c = JSON.stringify(r), /^[\{\[]/.test(c) && (r = c);
          } catch (e2) {
          }
          r = o.write ? o.write(r, n2) : encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), n2 = (n2 = (n2 = encodeURIComponent(String(n2))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
          var s = "";
          for (var f in i) i[f] && (s += "; " + f, true !== i[f] && (s += "=" + i[f]));
          return document.cookie = n2 + "=" + r + s;
        }
        n2 || (c = {});
        for (var p = document.cookie ? document.cookie.split("; ") : [], d = /(%[0-9A-Z]{2})+/g, u = 0; u < p.length; u++) {
          var l = p[u].split("="), C = l.slice(1).join("=");
          this.json || '"' !== C.charAt(0) || (C = C.slice(1, -1));
          try {
            var g = l[0].replace(d, decodeURIComponent);
            if (C = o.read ? o.read(C, g) : o(C, g) || C.replace(d, decodeURIComponent), this.json) try {
              C = JSON.parse(C);
            } catch (e2) {
            }
            if (n2 === g) {
              c = C;
              break;
            }
            n2 || (c[g] = C);
          } catch (e2) {
          }
        }
        return c;
      }
    }
    return t.set = t, t.get = function(e2) {
      return t.call(t, e2);
    }, t.getJSON = function() {
      return t.apply({ json: true }, [].slice.call(arguments));
    }, t.defaults = {}, t.remove = function(n2, o2) {
      t(n2, "", e(o2, { expires: -1 }));
    }, t.withConverter = n, t;
  }
  return n(function() {
  });
});
(function(b, c) {
  var $2 = b.jQuery || b.Cowboy || (b.Cowboy = {}), a;
  $2.throttle = a = function(e, f, j, i) {
    var h, d = 0;
    if (typeof f !== "boolean") {
      i = j;
      j = f;
      f = c;
    }
    function g() {
      var o = this, m = +/* @__PURE__ */ new Date() - d, n = arguments;
      function l() {
        d = +/* @__PURE__ */ new Date();
        j.apply(o, n);
      }
      function k() {
        h = c;
      }
      if (i && !h) {
        l();
      }
      h && clearTimeout(h);
      if (i === c && m > e) {
        l();
      } else {
        if (f !== true) {
          h = setTimeout(i ? k : l, i === c ? e - m : e);
        }
      }
    }
    if ($2.guid) {
      g.guid = j.guid = j.guid || $2.guid++;
    }
    return g;
  };
  $2.debounce = function(d, e, f) {
    return f === c ? a(d, e, false) : a(d, f, e !== false);
  };
})(this);
(function(a) {
  a.fn.prepareTransition = function() {
    return this.each(function() {
      var b = a(this);
      b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function() {
        b.removeClass("is-transitioning");
      });
      var c = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
      var d = 0;
      a.each(c, function(a2, c2) {
        d = parseFloat(b.css(c2)) || d;
      });
      if (d != 0) {
        b.addClass("is-transitioning");
        b[0].offsetWidth;
      }
    });
  };
})(jQuery);
if (typeof Shopify === "undefined") {
  Shopify = {};
}
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = "", placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || this.money_format;
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      var parts = number.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), cents2 = parts[1] ? decimal + parts[1] : "";
      return dollars + cents2;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
}
function shuffle(array) {
  var m = array.length, t, i;
  while (m) {
    i = Math.floor(Math.random() * m--);
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }
  return array;
}
window.vsp = window.vsp || {};
vsp.desktopAbove = 1049;
vsp.cacheSelectors = function() {
  vsp.cache = {
    // General
    $html: $("html"),
    $body: $("body"),
    // Navigation
    $navigation: $("#AccessibleNav"),
    // Customer Pages
    $recoverPasswordLink: $("#RecoverPassword"),
    $hideRecoverPasswordLink: $("#HideRecoverPasswordLink"),
    $recoverPasswordForm: $("#RecoverPasswordForm"),
    $customerLoginForm: $("#CustomerLoginForm"),
    $passwordResetSuccess: $("#ResetSuccess")
  };
};
vsp.init = function() {
  vsp.wishlist();
  vsp.cartWishlistViews(window.swat);
  $("a[href^='http']").each(function() {
    var $link = $(this);
    if ($link.attr("href").indexOf("https://vspconsignment.com") !== 0) {
      $link.attr("target", "_blank");
    }
  });
  vsp.nav();
  vsp.desktopNavLeft();
  vsp.searchOverlayThemeEditor();
  vsp.homeBannerThemeEditor();
  vsp.localization();
  if ($(".item-view").length) {
    vsp.product();
  }
  if ($("body").attr("data-template") == "cart") {
    vsp.cart();
  }
  if ($("body[data-template='collection']").length) {
    vsp.collection();
  }
  if ($(".recently-viewed-page-grid-wrapper").length) {
    var hasRecentlyViewed = vsp.displayRecentlyViewedProducts({
      $destination: $(".recently-viewed-page-grid-wrapper .item-grid"),
      limit: 48
    });
    if (!hasRecentlyViewed) {
      $(".recently-viewed-empty-message").show();
    }
  }
  if ($(".related-blog-posts").length) {
    vsp.blogArticle();
  }
  vsp.grid();
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      vsp.grid();
    }
  });
  vsp.cacheSelectors();
  vsp.loginForms();
  vsp.setupLiveSearch();
  vsp.trackSoldOutContinueShopping();
  vsp.trackSearchSidebar();
  vsp.trackSiteEvents();
  vsp.trackSearchBackLanding();
  vsp.trackCart();
  vsp.trackWishlistAvailability();
  vsp.newsletterPrompt();
  vsp.hardLoadedSearchPage();
  vsp.blog();
  vsp.homepage();
  vsp.pages();
  if (window.isHomePageCollection) {
    $(".main-nav .handle-new").addClass("active");
  }
  $(window).on("scroll", $.throttle(100, vsp.handleScroll));
  vsp.handleScroll();
  $("[data-show-header-dropdown]").on("mouseover", (event) => {
    let headerKey = event.currentTarget.getAttribute("data-show-header-dropdown");
    $(`.nav-dropdown.visible`).removeClass("visible");
    $dropdown = $(`.nav-dropdown[data-key="${headerKey}"]`);
    if ($dropdown.length) {
      $dropdown.addClass("visible");
    }
  });
  $(".nav-dropdown").on("mouseleave", (event) => {
    $visible = $(`.nav-dropdown.visible`);
    $visible.removeClass("visible");
    if ($visible.attr("data-key") == "shop") {
      $visible.find(".hover-image.visible").removeClass("visible");
      $visible.find(".hover-image:first-child").addClass("visible");
    }
  });
  $(".nav-dropdown .shows-hover-image").mouseenter(function(e) {
    console.log("in", e.currentTarget);
    const linkEl = e.currentTarget;
    const hoverId = linkEl.getAttribute("data-hover-image-id");
    if ($(`.hover-image[data-hover-image-id="${hoverId}"]`)) {
      $(`.hover-image.visible`).removeClass("visible");
      $(`.hover-image[data-hover-image-id="default"]`).removeClass("visible");
      $(`.hover-image[data-hover-image-id="${hoverId}"]`).addClass("visible");
    }
  }).mouseleave(function() {
    console.log("out");
  });
  vsp.renderRecentSearches();
  var inThemeEditor = window.Shopify && Shopify.designMode;
  if (!inThemeEditor && $(".search-featured-list > li").length > 5) {
    var $featuredItems = $(".search-featured-list > li");
    $(".search-featured-list").empty().append(shuffle($featuredItems));
  }
  $(".authenticity-certificate-add").on("click", (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    const $clicked = $(event.currentTarget);
    const id = parseInt($clicked[0].getAttribute("data-product-id"), 10);
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        "id": id
      },
      dataType: "json",
      success: function(data) {
        jQuery.getJSON("/cart.js", function(cart, textStatus) {
          console.log("cart", cart);
          $(".header-cart-item").attr("data-cart-count", cart.item_count);
          $(".header-cart-item .cart-count").text(cart.item_count);
        });
        if (vsp.cartDrawer) {
          vsp.cartDrawer.updateAndShow();
        }
      },
      error: function(data) {
        alert(data.responseJSON.description);
      }
    });
  });
  $(".authenticity-certificate-dismiss").on("click", (event) => {
    vsp.hideOverlay();
    if (window.vsp && window.vsp.cartDrawer) {
      window.vsp.cartDrawer.updateAndShow();
    }
  });
};
vsp.handleScroll = function() {
  if (vsp.isProductPage) {
    const itemBasics = document.querySelector(".item-info-basics");
    const itemBasicsRect = itemBasics.getBoundingClientRect();
    let headerHeight2 = 0;
    if (document.body.getAttribute("data-scroll-direction") == "up") {
      headerHeight2 = document.querySelector(".main-nav").offsetHeight;
    }
    const productPageItemBasicsOutOfView = itemBasicsRect.y - headerHeight2 < 0;
    if (productPageItemBasicsOutOfView != vsp.productPageItemBasicsOutOfView) {
      document.body.setAttribute("data-product-basics-out-of-view", productPageItemBasicsOutOfView);
      vsp.productPageItemBasicsOutOfView = productPageItemBasicsOutOfView;
      console.log("productPageItemBasicsOutOfView", productPageItemBasicsOutOfView);
    }
  }
  var $stickyCollectionBar = $(".sticky-collection-filter-bar");
  var scrollTop = Math.round($(window).scrollTop());
  var scrollDirection;
  if (vsp.previousScrollTop) {
    if (scrollTop > vsp.previousScrollTop + 5) {
      scrollDirection = "down";
    } else if (scrollTop < vsp.previousScrollTop - 5) {
      scrollDirection = "up";
    } else {
      scrollDirection = "none";
    }
  }
  if (scrollDirection !== "none" && vsp.scrollDirection !== scrollDirection) {
    vsp.scrollDirection = scrollDirection;
    $("body").attr("data-scroll-direction", scrollDirection);
  }
  var headerTop = $(".main-nav").offset().top;
  var headerHeight = $(".main-nav").outerHeight();
  var atTop = scrollTop === 0;
  var headerAtTop = headerTop === scrollTop;
  var scrolledPastHeader = scrollTop > headerHeight;
  if (scrolledPastHeader !== vsp.scrolledPastHeader) {
    vsp.scrolledPastHeader = scrolledPastHeader;
    $("body").attr("data-scrolled-past-header", scrolledPastHeader);
  }
  if ($stickyCollectionBar.length) {
    stickyCollectionBarIsSticky = $stickyCollectionBar.offset().top <= scrollTop;
    if (stickyCollectionBarIsSticky != vsp.stickyCollectionBarIsSticky) {
      vsp.stickyCollectionBarIsSticky = stickyCollectionBarIsSticky;
      $("body").attr("data-sticky-collection-bar-is-sticky", stickyCollectionBarIsSticky);
    }
  }
  if (atTop !== vsp.scrolledToTop) {
    vsp.scrolledToTop = atTop;
    $("body").toggleClass("scrolled-to-top", atTop);
  }
  if (headerAtTop !== vsp.headerAtTop) {
    vsp.headerAtTop = headerAtTop;
    $("body").toggleClass("header-scrolled-to-top", headerAtTop);
  }
  const targetElements = document.querySelectorAll("[data-section-can-change-header-style]");
  var elementUnderHeader = null;
  for (let element of targetElements) {
    var elementRect = element.getBoundingClientRect();
    var underHeader = elementRect.top < 60 && elementRect.bottom > 60;
    if (!elementUnderHeader && underHeader) {
      elementUnderHeader = element;
    }
  }
  if (elementUnderHeader) {
    $(".main-nav").attr("data-override-style", $(elementUnderHeader).attr("data-header-style"));
  } else {
    $(".main-nav").attr("data-override-style", "");
  }
  vsp.previousScrollTop = scrollTop;
};
vsp.getBrandData = function() {
  if (vsp.brandData) {
    return jQuery.Deferred().resolve(vsp.brandData);
  }
  return jQuery.getJSON("/search?view=vendor-json");
};
vsp.setupBrandSuggestions = function() {
  var dfd = jQuery.Deferred();
  if (vsp.brandMatcher) {
    dfd.resolve();
  } else {
    vsp.brandSuggestionOptions = {
      shouldSort: true,
      includeScore: true,
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ["brandName", "brandHandle"]
    };
    vsp.getBrandData().then(function(data) {
      vsp.brandData = data.vendors;
      vsp.brandMatcher = new Fuse(vsp.brandData, vsp.brandSuggestionOptions);
      dfd.resolve();
    });
  }
  return dfd.promise();
};
vsp.hardLoadedSearchPage = function() {
  if ($("body").attr("data-template") !== "search") {
    return false;
  }
  if ($(".empty-search-results").length && vsp.hardLoadedSearchTerms) {
    vsp.emptySearchResults($(".empty-search-results"), vsp.hardLoadedSearchTerms);
  }
};
vsp.getBrandSuggestionForString = function(string) {
  if (!vsp.brandMatcher) {
    return null;
  }
  if (!vsp.brandData) {
    vsp.getBrandData();
  }
  return vsp.brandMatcher.search(string);
};
vsp.blog = function() {
  var $allVideos = $(".article-content-text iframe[src*='//www.youtube.com']"), $fluidEl = $(".article-content-text");
  $allVideos.each(function() {
    $(this).data("aspectRatio", this.height / this.width).removeAttr("height").removeAttr("width");
  });
  $(window).resize(function() {
    var newWidth = $fluidEl.width();
    $allVideos.each(function() {
      var $el = $(this);
      $el.width(newWidth).height(newWidth * $el.data("aspectRatio"));
    });
  }).resize();
};
vsp.updateCartCount = function(count) {
  $("[data-cart-count]").attr("data-cart-count", count);
  $(".cart-count").text(count);
};
vsp.getMoreItems = function(event) {
  var $link, url;
  if (vsp.loading) {
    return;
  }
  $link = $(event.currentTarget);
  url = $link.attr("href");
  $link.text("Loading more items...");
  $grid = $(".item-grid");
  $footer = $(".secondary-nav:visible").last().clone();
  vsp.loading = true;
  $.ajax({
    url,
    dataType: "html",
    complete: function(jqXHR, status) {
      var items;
      vsp.loading = false;
      $link.parents(".pagination").remove();
      if (status === "success") {
        $response = $("<div>").html(jqXHR.responseText);
        $items = $response.find(".item-grid").children();
        $pagination = $response.find(".pagination");
        if ($footer.length) {
          $grid.append($footer);
        }
        $grid.append($items).after($pagination);
      }
    }
  });
};
vsp.startGridSlideshow = function(slideWrapper, duration) {
  if ($(slideWrapper).children().length < 2) {
    return;
  }
  $(slideWrapper).addClass("slideshow-active");
  $(slideWrapper).children().first().addClass("visible");
  return setInterval(function() {
    return vsp.advanceSlideshow(slideWrapper);
  }, duration);
};
vsp.advanceSlideshow = function(slideWrapper) {
  if (document.hidden) {
    return false;
  }
  if (!vsp.elementInViewport(slideWrapper)) {
    return false;
  }
  var $wrapper, length, nextVisibleIndex, visible, visibleIndex;
  $wrapper = $(slideWrapper);
  $items = $wrapper.find("img");
  length = $wrapper.find("img").length;
  visible = $wrapper.find(".visible")[0];
  visibleIndex = $(visible).index();
  nextVisibleIndex = visibleIndex + 1;
  if (nextVisibleIndex > length - 1) {
    nextVisibleIndex = 0;
  }
  $items.eq(visibleIndex).removeClass("visible");
  $items.eq(nextVisibleIndex).addClass("visible");
};
vsp.elementInViewport = function(element) {
  var rect = element.getBoundingClientRect();
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
};
vsp.grid = function() {
};
vsp.newsletterPrompt = function() {
  if (!$(".newsletter-prompt-close").length) {
    return;
  }
  vsp.newsletterPromptShown = false;
  $("body").on("click", ".newsletter-prompt-close", function() {
    Cookies.set("newsletter-prompt-dismissed", "true", { expires: 2 });
    $(".newsletter-prompt").addClass("hiding").removeClass("visible");
  });
  $("body").on("click", ".show-newsletter-signup", vsp.showNewsletterPrompt);
  if ($("body").attr("data-template") === "collection" && $(".newsletter-prompt").length && !Cookies.get("newsletter-prompt-dismissed")) {
    var viewportHeight = $(window).height();
    $(window).on("scroll", function() {
      if (!vsp.newsletterPromptShown && $(window).scrollTop() > viewportHeight) {
        vsp.showNewsletterPrompt();
      }
    });
  }
};
vsp.showNewsletterPrompt = function() {
  $(".newsletter-prompt").addClass("visible");
  vsp.newsletterPromptShown = true;
};
vsp.localization = function() {
  $("body").on("click", "#currency_form [data-value]", function(e) {
    e.preventDefault();
    let $clicked = $(e.currentTarget);
    let value = $clicked.attr("data-value");
    let $form = $clicked.closest("form");
    let $input = $form.find("[name='currency']");
    $input.val(value);
    if (value == "USD") {
      const oldUrlBase = `${window.location.origin}${Shopify.routes.root}`;
      const newUrlBase = `${window.location.origin}/en-us/`;
      const newUrl = window.location.href.replace(oldUrlBase, newUrlBase);
      window.location = newUrl;
    } else {
      $form.submit();
    }
  });
};
vsp.DESKTOP_NAV_LEFT_SELECTOR = "[data-desktop-nav-left]";
vsp.DESKTOP_NAV_LEFT_PANE_GAP_PX = 35;
vsp.DESKTOP_NAV_LEFT_BACKDROP_HIDE_DELAY_MS = 400;
vsp.DESKTOP_NAV_LEFT_BACKDROP_ALWAYS = true;
vsp.desktopNavLeftDefaultImageLink = function($nav) {
  if (!vsp.DESKTOP_NAV_LEFT_BACKDROP_ALWAYS) {
    return null;
  }
  const $pane = $nav.find(".desktop-nav-left-pane.active");
  return $pane.find(".desktop-nav-left-shop-all[data-hover-image-src]")[0] || $pane.find("[data-hover-image-src]")[0] || null;
};
vsp.desktopNavLeftBackdropHideTimer = null;
vsp.desktopNavLeftPaneFor = function(tabLink) {
  return $(tabLink).siblings(".desktop-nav-left-pane");
};
vsp.desktopNavLeftTabHasPane = function(tabLink) {
  return vsp.desktopNavLeftPaneFor(tabLink).find(".desktop-nav-left-group").length > 0;
};
vsp.openDesktopNavLeft = function(tabLink) {
  const $nav = $(tabLink).closest(vsp.DESKTOP_NAV_LEFT_SELECTOR);
  if (!vsp.desktopNavLeftTabHasPane(tabLink)) {
    vsp.closeDesktopNavLeft($nav);
    return;
  }
  const tabsBottom = $nav.find(".desktop-nav-left-tabs")[0].getBoundingClientRect().bottom;
  $nav[0].style.setProperty("--desktop-nav-left-pane-top", `${Math.round(tabsBottom + vsp.DESKTOP_NAV_LEFT_PANE_GAP_PX)}px`);
  const $pane = vsp.desktopNavLeftPaneFor(tabLink);
  const paneChanged = !$pane.hasClass("active");
  $nav.find(".desktop-nav-left-tab.active").not(tabLink).removeClass("active");
  $nav.find(".desktop-nav-left-pane.active").not($pane).removeClass("active");
  $(tabLink).addClass("active");
  $pane.addClass("active");
  $nav.attr("data-open", "");
  if (paneChanged) {
    vsp.preloadDesktopNavLeftImages($pane);
    vsp.showDesktopNavLeftImage($nav, vsp.desktopNavLeftDefaultImageLink($nav));
  }
  if (vsp.DESKTOP_NAV_LEFT_BACKDROP_ALWAYS) {
    $nav.attr("data-backdrop-visible", "");
  }
};
vsp.indexDesktopNavLeftStagger = function($pane) {
  if ($pane[0].dataset.staggerIndexed) {
    return;
  }
  $pane.find(".desktop-nav-left-group-header, .desktop-nav-left-links > li").each(function(staggerIndex) {
    this.style.setProperty("--stagger-index", staggerIndex);
  });
  $pane[0].dataset.staggerIndexed = "true";
};
vsp.DESKTOP_NAV_LEFT_PRELOAD_DELAY_MS = 800;
vsp.preloadDesktopNavLeftImages = function($pane) {
  clearTimeout(vsp.desktopNavLeftPreloadTimer);
  vsp.desktopNavLeftPreloadTimer = setTimeout(function() {
    const $nav = $pane.closest(".desktop-nav-left");
    if (!$pane.hasClass("active") || $nav.attr("data-open") === void 0) {
      return;
    }
    $pane.find("[data-hover-image-src]").each(function() {
      if (this.dataset.hoverImagePreloaded) {
        return;
      }
      const preloader = new Image();
      preloader.sizes = "35vw";
      preloader.srcset = this.dataset.hoverImageSrcset;
      preloader.src = this.dataset.hoverImageSrc;
      this.dataset.hoverImagePreloaded = "true";
    });
  }, vsp.DESKTOP_NAV_LEFT_PRELOAD_DELAY_MS);
};
vsp.showDesktopNavLeftImage = function($nav, link) {
  clearTimeout(vsp.desktopNavLeftBackdropHideTimer);
  const images = $nav.find(".desktop-nav-left-backdrop-image").get();
  const visibleImage = images.find((image) => image.classList.contains("visible"));
  const src = link ? link.dataset.hoverImageSrc : void 0;
  if (!src) {
    images.forEach((image) => image.classList.remove("visible"));
    $nav[0].dataset.hoverImageSrc = "";
    $nav.removeAttr("data-backdrop-visible");
    return;
  }
  if ($nav[0].dataset.hoverImageSrc === src) {
    return;
  }
  $nav[0].dataset.hoverImageSrc = src;
  const nextImage = images.find((image) => image !== visibleImage);
  const reveal = function() {
    if ($nav[0].dataset.hoverImageSrc !== src) {
      return;
    }
    images.forEach((image) => image.classList.toggle("visible", image === nextImage));
    $nav.attr("data-backdrop-visible", "");
  };
  nextImage.onload = reveal;
  nextImage.srcset = link.dataset.hoverImageSrcset;
  nextImage.src = src;
  if (nextImage.complete && nextImage.naturalWidth) {
    reveal();
  }
};
vsp.closeDesktopNavLeft = function($nav) {
  clearTimeout(vsp.desktopNavLeftPreloadTimer);
  $nav = $nav || $(vsp.DESKTOP_NAV_LEFT_SELECTOR);
  $nav.removeAttr("data-open");
  $nav.find(".desktop-nav-left-tab.active, .desktop-nav-left-pane.active").removeClass("active");
  $nav.each(function() {
    vsp.showDesktopNavLeftImage($(this), null);
  });
};
vsp.desktopNavLeft = function() {
  $("body").on("mouseenter focus", ".desktop-nav-left-tab", function() {
    vsp.openDesktopNavLeft(this);
  });
  $("body").on("mouseenter focus", ".desktop-nav-left-link[data-hover-image-src], .desktop-nav-left-shop-all[data-hover-image-src]", function() {
    vsp.showDesktopNavLeftImage($(this).closest(vsp.DESKTOP_NAV_LEFT_SELECTOR), this);
  });
  $("body").on("mouseleave blur", ".desktop-nav-left-link[data-hover-image-src], .desktop-nav-left-shop-all[data-hover-image-src]", function() {
    const $nav = $(this).closest(vsp.DESKTOP_NAV_LEFT_SELECTOR);
    clearTimeout(vsp.desktopNavLeftBackdropHideTimer);
    vsp.desktopNavLeftBackdropHideTimer = setTimeout(function() {
      vsp.showDesktopNavLeftImage($nav, vsp.desktopNavLeftDefaultImageLink($nav));
    }, vsp.DESKTOP_NAV_LEFT_BACKDROP_HIDE_DELAY_MS);
  });
  $("body").on("mouseleave", vsp.DESKTOP_NAV_LEFT_SELECTOR, function() {
    vsp.closeDesktopNavLeft($(this));
  });
  $("body").on("focusout", vsp.DESKTOP_NAV_LEFT_SELECTOR, function(e) {
    if (!e.relatedTarget || !this.contains(e.relatedTarget)) {
      vsp.closeDesktopNavLeft($(this));
    }
  });
  $(document).on("keydown", function(e) {
    if (e.key === "Escape") {
      vsp.closeDesktopNavLeft();
    }
  });
  let touchTabWasActive = true;
  $("body").on("pointerdown", ".desktop-nav-left-tab", function(e) {
    touchTabWasActive = e.pointerType !== "touch" || $(this).hasClass("active");
  });
  $("body").on("click", ".desktop-nav-left-tab", function(e) {
    if (!touchTabWasActive && vsp.desktopNavLeftTabHasPane(this)) {
      e.preventDefault();
      vsp.openDesktopNavLeft(this);
    }
    touchTabWasActive = true;
  });
  $(document).on("pointerdown", function(e) {
    if (e.pointerType === "touch" && !$(e.target).closest(vsp.DESKTOP_NAV_LEFT_SELECTOR).length) {
      vsp.closeDesktopNavLeft();
    }
  });
  document.addEventListener("shopify:block:select", function(e) {
    const $target = $(e.target);
    const $tabItem = $target.closest(".desktop-nav-left-tab-item").add($target.find(".desktop-nav-left-tab-item")).first();
    if ($tabItem.length) {
      vsp.openDesktopNavLeft($tabItem.find(".desktop-nav-left-tab")[0]);
    }
  });
  document.addEventListener("shopify:block:deselect", function() {
    vsp.closeDesktopNavLeft();
  });
};
vsp.nav = function() {
  $("body").on("click", ".header-icons .menu-trigger-item", function(e) {
    if ($(".main-nav").hasClass("menu-visible")) {
      $(".main-nav").removeClass("menu-visible");
      $(".header-icons .menu-trigger-item").attr("data-open", "false");
    } else {
      $(".main-nav").addClass("menu-visible");
      $(".header-icons .menu-trigger-item").attr("data-open", "true");
      setTimeout(function() {
        $(".nav-viewport .menu-pane").first().addClass("active");
      }, 500);
    }
  });
  $("body").on("click", "[data-show-overlay]", function(e) {
    e.stopPropagation();
    e.preventDefault();
    const overlayName = $(this).attr("data-show-overlay");
    const stackOverCart = overlayName === "wishlist-logged-out" && $("body").attr("data-visible-overlay") === "cart";
    renderTemplate(overlayName);
    if (overlayName === "contact-form") {
      const contactItemName = $(this).attr("data-item-name");
      if (contactItemName) {
        $("#contact_form #ItemName").val(contactItemName);
      }
    }
    if (overlayName == "wishlist-logged-out") {
      let destination = $(this).attr("data-post-login-path");
      vsp.logWishlistEvent("wishlist_login_prompt", { source: vsp.wishlistSource(this), product: vsp.wishlistProductHandle(destination) });
      if (destination && destination.length) {
        $(".wishlist-logged-out-overlay .account-required-notice [data-href]").attr("href", vsp.loginUrlReturningTo(destination));
      }
    }
    if (overlayName.includes("size-guide") && $(this).attr("data-generic-size")) {
      const genericSize = $(this).attr("data-generic-size");
      console.log("genericSize", genericSize);
      $("body").attr("size-guide-active-size-generic-overlay", genericSize);
    }
    setTimeout(function() {
      if (stackOverCart) {
        $("body").attr("data-cart-suboverlay", overlayName);
      } else {
        vsp.showOverlay(overlayName);
      }
    }, 10);
  });
  $("body").on("click", "[data-hide-overlay]", function(e) {
    e.stopPropagation();
    e.preventDefault();
    vsp.hideOverlay();
  });
  $(".site-wrap").on("click", function(event) {
    if ($("body").attr("data-visible-overlay") === "nav-overlay") {
      event.preventDefault();
      vsp.hideOverlay();
    }
  });
  $(document).on("keyup", function(e) {
    if (e.keyCode === 27) {
      vsp.hideOverlay();
    }
  });
  if (vsp.homepageCollectionUrl) {
    $(".main-menu a[href='" + vsp.homepageCollectionUrl + "']").parent("li").addClass("active");
  }
  $("body").on("click", ".close-overlay", function(e) {
    if ($("body").attr("data-cart-suboverlay") && $(this).closest(".wishlist-logged-out-overlay").length) {
      $("body").removeAttr("data-cart-suboverlay");
      return;
    }
    if (vsp.visibleOverlay === "quick-view" && vsp.overlayUnderQuickView) {
      vsp.hideOverlay();
      return;
    }
    $("body").removeAttr("data-visible-overlay");
  });
  $(".search-form-ui").on("click", function(event) {
    if ($(event.target).closest(".search-form-ui-clear, .search-form-ui-close").length) return;
    $(this).find(".search-form-input:visible").focus();
  });
  $(".search-form-ui-clear").on("click", function(event) {
    event.preventDefault();
    var $wrap = $(event.currentTarget).closest(".search-wrap");
    $wrap.find(".search-form-input").val("");
    vsp.resetLiveSearch($wrap);
    $wrap.find(".search-form-input:visible").focus();
  });
  $(".search-form-ui-close").on("click", function(event) {
    event.preventDefault();
    if (vsp.searchPageMode) {
      var cameFromSite = document.referrer.indexOf(window.location.origin) === 0;
      if (cameFromSite && history.length > 1) {
        history.back();
      } else {
        window.location.href = "/";
      }
    } else {
      vsp.hideOverlay("search");
    }
  });
  $("body").on("click", ".search-wrap .popular-search-term", function(event) {
    event.stopPropagation();
    event.preventDefault();
    var $clicked = $(event.currentTarget);
    var term = $clicked.attr("data-term");
    var $input = $clicked.closest(".search-wrap").find(".search-form-input:visible");
    if (term) {
      vsp.saveRecentSearch(term);
      vsp.renderRecentSearches();
    }
    $input.val(term).change();
  });
  $(".alert-banner-wrap .alert-banner-close").on("click", function() {
    $("#shopify-section-alert-banner").removeClass("visible");
  });
  $("body").on("click", ".nav-viewport a.has-third-level", function(e) {
    var $clicked = $(e.currentTarget);
    var opening = !$clicked.hasClass("expanded");
    var $row = $clicked.closest("li");
    var $submenu = $row.find(".third-level-menu");
    var $submenuWrap = $row.find(".third-level-menu-wrap");
    var submenuHeight = $submenu.height();
    if (opening) {
      $submenuWrap.height(submenuHeight);
    } else {
      $submenuWrap.height(0);
    }
    $clicked.toggleClass("expanded");
  });
  $("body").on("click", ".nav-viewport .navigate-to-submenu", function(e) {
    var $clicked = $(e.currentTarget), handle = $clicked.attr("data-key"), $li = $clicked.closest("li"), $submenu = $(`.menu-pane[data-parent-key='${handle}']`), $mainmenu2 = $clicked.closest(".menu-pane[data-level='0']");
    $mainmenu2.removeClass("active");
    $submenu.addClass("active");
    $(".mobile-menu-back-to-mainmenu").addClass("visible");
    $(".nav-viewport-content").attr("data-active-level", "1");
  });
  $("body").on("click", ".mobile-menu-back-to-mainmenu", function(e) {
    var $clicked = $(e.currentTarget), $submenu = $(".menu-pane.active");
    $mainmenu = $(".menu-pane[data-level='0']");
    $submenu.removeClass("active");
    $mainmenu.addClass("active");
    $(".nav-viewport-content").attr("data-active-level", "0");
    setTimeout(function() {
      $submenu.find(".has-third-level.expanded").removeClass("expanded");
      $submenu.find(".third-level-menu-wrap").height(0);
    }, 500);
    $(".mobile-menu-back-to-mainmenu").removeClass("visible");
  });
  if (window.innerWidth > vsp.desktopAbove) {
    $(".submenu-toggle[data-default-open-on-desktop]").addClass("active");
  }
}, // Theme Editor: selecting the Search section opens the search overlay so its
// settings and blocks can be seen while editing; deselecting closes it.
// showOverlay toggles, so only call it when the overlay isn't already open.
vsp.searchOverlayThemeEditor = function() {
  if (!(window.Shopify && Shopify.designMode)) {
    return;
  }
  const isSearchSection = (event) => event.detail && event.detail.sectionId === "search";
  const openSearchOverlay = function(event) {
    if (vsp.searchPageMode) return;
    if (isSearchSection(event) && $("body").attr("data-visible-overlay") !== "search") {
      vsp.showOverlay("search");
    }
  };
  document.addEventListener("shopify:section:select", openSearchOverlay);
  document.addEventListener("shopify:block:select", openSearchOverlay);
  document.addEventListener("shopify:section:deselect", function(event) {
    if (isSearchSection(event) && $("body").attr("data-visible-overlay") === "search") {
      vsp.hideOverlay();
    }
  });
};
vsp.homeBannerThemeEditor = function() {
  if (!(window.Shopify && Shopify.designMode)) {
    return;
  }
  const showBanner = function(event) {
    const section = event.target;
    if (!section || !section.classList || !section.classList.contains("home-banner-section")) return;
    document.querySelectorAll(".home-banner-section--chosen").forEach(function(other) {
      if (other !== section) other.classList.remove("home-banner-section--chosen");
    });
    section.classList.add("home-banner-section--chosen");
    if (window.vspHomeBannerActivate) window.vspHomeBannerActivate(section);
  };
  document.addEventListener("shopify:section:select", showBanner);
  document.addEventListener("shopify:section:load", showBanner);
};
vsp.hideOverlay = function() {
  if ($("body").attr("data-cart-suboverlay")) {
    $("body").removeAttr("data-cart-suboverlay");
    return;
  }
  if (vsp.visibleOverlay === "quick-view" && vsp.overlayUnderQuickView) {
    var underlyingOverlay = vsp.overlayUnderQuickView;
    vsp.overlayUnderQuickView = null;
    $("body").attr("data-visible-overlay", underlyingOverlay);
    vsp.visibleOverlay = underlyingOverlay;
    return;
  }
  var searchTerm = $(".search-overlay .search-form-input:visible").val();
  if (searchTerm && searchTerm.trim().length >= 3) {
    vsp.saveRecentSearch(searchTerm.trim());
  }
  $("body").removeAttr("data-visible-overlay");
  vsp.visibleOverlay = null;
  if (vsp.searchHistoryPushed) {
    vsp.searchHistoryPushed = false;
    history.back();
  }
  vsp.preOverlayURL = null;
  bodyScrollLock.enableBodyScroll(document.querySelectorAll(".search-overlay .overlay-inner")[0]);
};
vsp.showOverlay = function(name) {
  if ($("body").attr("data-visible-overlay") === name) {
    vsp.hideOverlay();
  } else {
    vsp.overlayUnderQuickView = name === "quick-view" && vsp.visibleOverlay === "search" ? "search" : null;
    $("body").attr("data-visible-overlay", name);
    vsp.visibleOverlay = name;
    if ($('[data-overlay-content="' + name + '"] img[data-overlay-content-img-src]').length) {
      $('[data-overlay-content="' + name + '"] img[data-overlay-content-img-src]').each(function() {
        var $img = $(this);
        $img.attr("src", $img.attr("data-overlay-content-img-src"));
        if ($img.attr("data-overlay-content-img-srcset")) {
          $img.attr("srcset", $img.attr("data-overlay-content-img-srcset"));
        }
      });
    }
    ;
    if (name === "cart" && vsp.logCartView && !(vsp.cartDrawer && vsp.cartDrawer.logViewAfterUpdate)) {
      vsp.logCartView("drawer");
    }
    if (name === "search") {
      vsp.preOverlayURL = window.location.href;
      vsp.searchHistoryPushed = false;
      vsp.searchGenderForView = null;
      vsp.renderRecentSearches();
      vsp.syncSearchGenderToggle();
      $(".search-overlay .search-form-input:visible").focus();
      bodyScrollLock.disableBodyScroll(document.querySelectorAll(".search-overlay .overlay-inner")[0]);
    }
    if (name === "nav-overlay") {
      if (vsp.cartCount !== void 0) {
        $(".nav-overlay [data-cart-count]").attr("data-cart-count", vsp.cartCount);
        $(".nav-overlay .cart-count").text(vsp.cartCount);
      }
    }
  }
}, vsp.runFilterSubsearch = function($block, $input, searcher) {
  const blockId = $block.attr("id");
  const value = $input.val().trim();
  if (!!value.length) {
    vsp.currentSubsearchTerms[blockId] = value;
    const results = searcher.search(value);
    const $items2 = $block.find(".facets__item[data-subsearch-value]");
    $items2.attr("data-matches", "false");
    results.forEach(function(result) {
      $items2.filter("[data-subsearch-id='" + result.item.id + "']").attr("data-matches", "true");
    });
    $block.attr("data-subsearch-active", "true");
    $block.find(".facets-subsearch-wrap").attr("data-populated", "true");
  } else {
    delete vsp.currentSubsearchTerms[blockId];
    const $items2 = $block.find(".facets__item[data-subsearch-value]");
    $items2.attr("data-matches", "true");
    $block.attr("data-subsearch-active", "false");
    $block.find(".facets-subsearch-wrap").attr("data-populated", "false");
  }
}, vsp.initFilterSubsearch = function($block) {
  vsp.currentSubsearchTerms = vsp.currentSubsearchTerms || {};
  const subsearchData = [];
  const blockId = $block.attr("id");
  if (!$block.hasClass("supports-subsearch")) {
    return;
  }
  $block.find(".facets__item[data-subsearch-value]").each(function(index2, element) {
    subsearchData.push({
      value: element.dataset.subsearchValue,
      valueNoDot: element.dataset.subsearchValueNoDot,
      handle: element.dataset.subsearchHandle,
      id: element.dataset.subsearchId
    });
  });
  vsp.filterSubsearchers = vsp.filterSubsearchers || {};
  const searcher = new Fuse(subsearchData, {
    includeScore: true,
    threshold: 0.1,
    keys: ["value", "handle", "valueNoDot"]
  });
  const $input = $block.find(".facets-subsearch");
  $block.on("input", ".facets-subsearch", function(event) {
    vsp.runFilterSubsearch($block, $input, searcher);
  });
  if (vsp.currentSubsearchTerms[blockId]) {
    $input.val(vsp.currentSubsearchTerms[blockId]);
  }
  $block.attr("subsearch-initialized", "true");
  $("body").on("click", ".filter-block.supports-subsearch .facets-subsearch-clear", function(event) {
    var $clicked = $(event.currentTarget), $block2 = $clicked.closest(".filter-block"), $input2 = $block2.find(".facets-subsearch");
    $input2.val("");
    vsp.runFilterSubsearch($block2, $input2, searcher);
  });
}, vsp.getSortByUrl = function(sortBy) {
  let params = new URL(document.location).searchParams;
  params.set("sort_by", sortBy);
  return location.pathname + "?" + params.toString();
};
vsp.collection = function() {
  if ($("[data-parent-collection-url]").length) {
    const link = $("[data-parent-collection-url]").attr("data-parent-collection-url");
    $(`.main-menu li a[href='${link}']`).closest("li").addClass("active");
  }
  $(".collection-description").each(function(i, el) {
    $(el).toggleClass("can-expand", el.scrollHeight > el.clientHeight);
  });
  $(".collection-description-expand").on("click", function() {
    $(".collection-description").addClass("expanded").removeClass("can-expand");
  });
  $("body").on("click", ".show-filter", function(event) {
    if (renderTemplate("collection-filter")) {
      setTimeout(function() {
        $(".collection-filter").addClass("visible");
      }, 50);
    } else {
      $(".collection-filter").addClass("visible");
    }
  });
  $("body").on("click", ".mailing-list-cta", function(event) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "VjcX8Z"]);
  });
  $("body").on("click", ".hide-filter", function(event) {
    $(".collection-filter").removeClass("visible");
  });
  $("body").on("click", function(event) {
    if ($(".collection-filter.visible").length) {
      if (!event.target.closest(".collection-filter") && !event.target.classList.contains("show-filter")) {
        console.log(event.target);
        $(".collection-filter").removeClass("visible");
      }
    }
  });
  $("body").on("focus", ".filter-block.supports-subsearch:not([subsearch-initialized])", function(event) {
    var $block = $(event.currentTarget);
    vsp.initFilterSubsearch($block);
  });
  $("body").on("click", "a[data-open-facet-on-next-load]", function(event) {
    event.preventDefault();
    sessionStorage.setItem(`facetOpen:${event.currentTarget.getAttribute("data-open-facet-on-next-load")}`, "true");
    window.location = event.currentTarget.getAttribute("href");
  });
}, // Session-cached wishlist social-count map (empi -> count) so grid pages and the
// PDP don't re-fetch the same counts. try/catch because sessionStorage can throw
// (private mode / quota).
vsp.WISHLIST_COUNT_CACHE_KEY = "vsp.wishlistCounts";
vsp.getWishlistCountCache = function() {
  try {
    return JSON.parse(sessionStorage.getItem(vsp.WISHLIST_COUNT_CACHE_KEY)) || {};
  } catch (e) {
    return {};
  }
};
vsp.setWishlistCount = function(id, count) {
  try {
    var cache = vsp.getWishlistCountCache();
    cache[id] = count;
    sessionStorage.setItem(vsp.WISHLIST_COUNT_CACHE_KEY, JSON.stringify(cache));
  } catch (e) {
  }
};
vsp.itemGridWishlist = function(swat) {
  $(".item-grid-item:not(.wishlist-count-fetched)").each(function() {
    const itemEl = $(this)[0];
    const id = itemEl.getAttribute("data-item-id");
    swat.wishlist.getSocialCount({ empi: id }, function(result) {
      itemEl.classList.add("wishlist-count-fetched");
      vsp.setWishlistCount(id, result.data.count);
      const threshold = window.vspconfig ? window.vspconfig.oftenWishlistedBadgeThreshold : 2;
      if (result.data.count > threshold) {
        itemEl.classList.add("popular-wishlist-item");
      }
    }, function(error) {
      console.log("wishlist error", error);
    });
  });
};
vsp.renderCartWishlistCount = function(element, count) {
  var minimumCount = parseInt(element.getAttribute("data-min-count"), 10);
  if (isNaN(minimumCount)) minimumCount = 3;
  if (typeof count !== "number" || count < minimumCount || count < 1) {
    element.hidden = true;
    element.textContent = "";
    return;
  }
  var template = count === 1 ? element.getAttribute("data-text-one") || "In 1 wishlist" : element.getAttribute("data-text") || "In [count] wishlists";
  element.textContent = template.replace("[count]", count);
  element.hidden = false;
};
vsp.renderCartWishlistCounts = function(swat) {
  var cache = vsp.getWishlistCountCache();
  var elements = document.querySelectorAll(".cart-item-wishlist-count[data-product-id]");
  Array.prototype.forEach.call(elements, function(element) {
    var productId = element.getAttribute("data-product-id");
    if (Object.prototype.hasOwnProperty.call(cache, productId)) {
      vsp.renderCartWishlistCount(element, cache[productId]);
    }
    if (!swat || element.classList.contains("wishlist-count-fetched")) return;
    element.classList.add("wishlist-count-fetched");
    swat.wishlist.getSocialCount(
      { empi: productId },
      function(result) {
        var count = result && result.data ? result.data.count : null;
        vsp.setWishlistCount(productId, count);
        vsp.renderCartWishlistCount(element, count);
      },
      function(error) {
        console.log("cart wishlist count error", error);
      }
    );
  });
};
vsp.cartWishlist = function(swat) {
  if (!swat) return;
  $("body").off("click.vspCartWishlist", ".move-cart-item-to-wishlist").on("click.vspCartWishlist", ".move-cart-item-to-wishlist", function(event) {
    event.preventDefault();
    const $link = $(event.currentTarget);
    const data = {
      du: $link[0].dataset.du,
      epi: parseInt($link[0].dataset.epi, 10),
      empi: parseInt($link[0].dataset.empi, 10)
    };
    swat.addToWishList(data, function() {
      vsp.addWishlistProductToCache(data);
      vsp.logWishlistEvent("wishlist_add", { source: vsp.wishlistSource($link), product: vsp.wishlistProductHandle(data.du) });
      $link.text("Moved to wishlist");
      const url = $link.attr("data-remove-url");
      setTimeout(function() {
        if ($link.closest("cart-drawer").length && vsp.cartDrawer) {
          fetch(url).then(function() {
            vsp.cartDrawer.update();
          });
        } else if ($link.closest(".cart-wishlist-page").length) {
          fetch(url).then(function() {
            vsp.refreshCartWishlistPage($link.closest(".cart-wishlist-page")[0], swat);
            if (vsp.cartDrawer) vsp.cartDrawer.update();
          });
        } else {
          window.location = url;
        }
      }, 500);
    }, function(error) {
      alert(`There was an error adding the product to wishlist: ${error}`);
    });
  });
};
vsp.productPageWishlist = function(swat) {
  if (!$("#wishlist-actions-template").length) return;
  var $targetButtons = $("input.AddToCart, .sold-out-button, .inquire-instead-of-add-to-cart-button");
  $targetButtons.each(function(i, el) {
    $targetButton = $(el);
    $targetButton.wrap("<div class='add-to-cart-button-wrap'></div>");
    const $parent = $targetButton.closest(".add-to-cart-button-wrap");
    const $buttons = $targetButton.closest(".buttons");
    const wishlistTemplate = $buttons.find("#wishlist-actions-template")[0];
    if (wishlistTemplate) {
      var documentFragment = wishlistTemplate.content;
      var templateClone = documentFragment.cloneNode(true);
      $parent.append(templateClone);
      $(".wishlist-actions").show();
    }
  });
  const itemData = {
    du: $(".wishlist-actions")[0].dataset.du,
    epi: parseInt($(".wishlist-actions")[0].dataset.epi, 10),
    empi: parseInt($(".wishlist-actions")[0].dataset.empi, 10)
  };
  $(".wishlist-actions .add-to-wishlist:not(.logged-out)").click(function() {
    $(".wishlist-actions").addClass("loading");
    swat.addToWishList(itemData, function(response) {
      $(".wishlist-actions").attr("data-product-is-wishlisted", "true");
      $(".wishlist-actions").removeClass("loading");
      vsp.addWishlistProductToCache(itemData);
      vsp.logWishlistEvent("wishlist_add", { source: "product_page", product: vsp.wishlistProductHandle(itemData.du) });
    }, function(error) {
      $(".wishlist-actions").removeClass("loading");
      alert(`There was an error adding the product to wishlist: ${error}`);
    });
  });
  $(".wishlist-actions .remove-from-wishlist:not(.logged-out)").click(function() {
    $(".wishlist-actions").addClass("loading");
    swat.removeFromWishList(itemData, function(response) {
      $(".wishlist-actions").attr("data-product-is-wishlisted", "false");
      $(".wishlist-actions").removeClass("loading");
      vsp.removeWishlistProductFromCache(itemData);
      vsp.logWishlistEvent("wishlist_remove", { source: "product_page", product: vsp.wishlistProductHandle(itemData.du) });
    }, function(error) {
      $(".wishlist-actions").removeClass("loading");
      alert(`There was an error removing the product from wishlist: ${error}`);
    });
  });
  if (document.body.classList.contains("customer-logged-in")) {
    vsp.fetchWishlistProducts(swat).then(function(allWishlistedProducts) {
      console.log("successfully retrieved the wishlist", allWishlistedProducts);
      for (item of allWishlistedProducts) {
        console.log("item", item);
        if (itemData.empi === item.empi) {
          $(".wishlist-actions").attr("data-product-is-wishlisted", "true");
        }
      }
    }).catch(function(error) {
      console.log("error loading wishlist, hiding");
      $(".wishlist-actions").hide();
    });
  }
  const itemViewEls = document.querySelectorAll(".item-view");
  itemViewEls.forEach(function(itemViewEl) {
    const productId = itemViewEl.getAttribute("data-product-id");
    const threshold = window.vspconfig ? window.vspconfig.oftenWishlistedBadgeThreshold : 2;
    function toggleWishlistedBadge(count) {
      itemViewEl.querySelectorAll(".product-page-badge--wishlisted").forEach(function(el) {
        el.style.display = count > threshold ? null : "none";
      });
    }
    swat.wishlist.getSocialCount({ empi: productId }, function(result) {
      vsp.setWishlistCount(productId, result.data.count);
      toggleWishlistedBadge(result.data.count);
    }, function(error) {
      console.log("xxx wishlist error on pdp getting count", error);
    });
  });
};
vsp.product = function() {
  vsp.isProductPage = true;
  $(".product-page-accordian details").each(function(index2, y) {
    const thisDetails = $(this)[0];
    thisDetails.addEventListener("toggle", (event) => {
      if (event.newState == "open") {
        $(".product-page-accordian details").each(function(index3, y2) {
          console.log("checking ", $(this)[0]);
          if ($(this)[0] != thisDetails && $(this)[0].open) {
            $(this).find("summary").click();
          }
        });
      }
      ;
    });
  });
  $(".lightbox-link").on("click", vsp.showImageLightbox);
  $(".view-all-photos-button").on("click", () => {
    $(".item-photo-link.hidden").removeClass("hidden");
    $(".view-all-photos-button").remove();
  });
  let lastLightboxImageIndex = 1;
  $(".image-overlay .overlay-inner").on("scroll", $.throttle(100, function(event) {
    const labelPosition = event.target.scrollTop + 43;
    let height = 0;
    let hasFoundCurrentLightboxImage = false;
    $(".image-overlay .overlay-inner img").each(function(index2, y) {
      height = height + $(this).height();
      if (!hasFoundCurrentLightboxImage && height > labelPosition) {
        hasFoundCurrentLightboxImage = true;
        lightboxImageIndex = index2 + 1;
      }
    });
    if (lastLightboxImageIndex != lightboxImageIndex) {
      $(".image-overlay .photo-counter span.current").text(lightboxImageIndex);
      lastLightboxImageIndex = lightboxImageIndex;
    }
  }));
  $(".image-overlay-next").on("click", function(e) {
    e.stopPropagation();
    vsp.advanceLightboxImage();
  });
  $(".image-overlay-prev").on("click", function(e) {
    e.stopPropagation();
    vsp.advanceLightboxImage(true);
  });
  $(".image-overlay").on("click", function() {
    vsp.hideImageLightbox();
  });
  $(document).on("keyup", function(e) {
    if (e.keyCode === 27) {
      vsp.hideImageLightbox();
    }
  });
  $(window).on("load", function() {
    vsp.relatedProducts();
    vsp.randomProductsFromCollection();
  });
  if ($(".customer-testimonials").length) {
    var $items2 = $(".customer-testimonials .customer-testimonial");
    var randomTwo = shuffle($items2).slice(0, 3);
    $(".customer-testimonials").empty().append(randomTwo);
  }
  const $mobileSlides = $(".item-photos.swiper .swiper-slide");
  if ($mobileSlides.length > 1) {
    vsp.mobileProductPhotosSwiper = new Swiper(".item-photos.swiper", {
      speed: 400,
      touchMoveStopPropagation: true,
      touchAngle: 60,
      loop: true,
      autoplay: {
        delay: 5e3
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
      // spaceBetween: 100,
    });
    vsp.mobileProductPhotosSwiper.on("slideChange", function() {
      $(".mobile-image-count-current-index").text(this.activeIndex);
    });
    var $photoThumbs = $(".mobile-photo-thumb");
    if ($photoThumbs.length) {
      let highlightActiveThumb2 = function(realIndex) {
        $photoThumbs.removeClass("active").attr("aria-current", null);
        $photoThumbs.filter('[data-thumb-index="' + realIndex + '"]').addClass("active").attr("aria-current", "true");
      };
      var highlightActiveThumb = highlightActiveThumb2;
      $photoThumbs.on("click", function() {
        var index2 = parseInt($(this).attr("data-thumb-index"), 10);
        vsp.mobileProductPhotosSwiper.slideToLoop(index2);
      });
      highlightActiveThumb2(vsp.mobileProductPhotosSwiper.realIndex);
      vsp.mobileProductPhotosSwiper.on("slideChange", function() {
        highlightActiveThumb2(this.realIndex);
      });
    }
  }
  if ($(".variant-selection").length) {
    $("#product-variants").hide();
    var currentVariantID = $("#product-select").val();
    $(".variant-selector[data-variant-id='" + currentVariantID + "']").addClass("selected");
    $(".variant-selector:not([disabled])").on("click", function() {
      var selectedVariantID = $(this).attr("data-variant-id");
      $("#product-select").val(selectedVariantID).change();
      $newChoice = $(this);
      $newChoice.closest(".variant-selection").find(".variant-selector").removeClass("selected");
      $newChoice.addClass("selected");
    });
  }
  var productTitle = $(".product-title").text();
  if ($("#contact_form").length) {
    if (vsp.currentItemTitle) {
      let title = vsp.currentItemTitle;
      if (vsp.currentItemDesigner) {
        title = `${vsp.currentItemDesigner} - ${title}`;
      }
      $("#contact_form #ItemName").val(title);
    }
  }
  var hasRecentlyViewed = vsp.displayRecentlyViewedProducts({
    $destination: $(".recently-viewed-products .item-grid")
  });
  if (hasRecentlyViewed) {
    $(".recently-viewed-products").addClass("visible");
  }
  setTimeout(function() {
    vsp.logRecentlyViewedProduct();
  }, 500);
}, vsp.logRecentlyViewedProduct = function() {
  try {
    var recentlyViewedKey = "recentlyViewed";
    var recentlyViewedHandles = JSON.parse(localStorage.getItem(recentlyViewedKey) || "[]");
    vsp.recentlyViewedHandles = recentlyViewedHandles;
    var productHandle = $("[data-product-handle]").attr("data-product-handle");
    if (!productHandle) {
      return null;
    }
    var currentHandleIndex = recentlyViewedHandles.indexOf(productHandle);
    if (currentHandleIndex !== -1) {
      recentlyViewedHandles.splice(currentHandleIndex, 1);
    }
    recentlyViewedHandles.unshift(productHandle);
    recentlyViewedHandles = recentlyViewedHandles.slice(void 0, 100);
    localStorage.setItem(recentlyViewedKey, JSON.stringify(recentlyViewedHandles));
  } catch (e) {
  }
};
vsp.displayRecentlyViewedProducts = function(options = {}) {
  try {
    var recentlyViewedKey = "recentlyViewed";
    var recentlyViewedHandles = JSON.parse(localStorage.getItem(recentlyViewedKey) || "[]");
    vsp.recentlyViewedHandles = recentlyViewedHandles;
    if (recentlyViewedHandles.length) {
      vsp.buildGridFromProductHandles(recentlyViewedHandles, options.$destination, options.limit);
      return true;
    } else {
      return null;
    }
  } catch (e) {
  }
};
vsp.buildGridFromProductHandles = function(recentlyViewedHandles, $destination, limit = 5) {
  if (!recentlyViewedHandles.length) {
    return null;
  }
  recentlyViewedHandles = recentlyViewedHandles.slice(void 0, limit);
  var promises = [];
  var fetchedHtml = [];
  for (let i = 0; i < recentlyViewedHandles.length; i++) {
    setTimeout(function() {
      jQuery.get("/products/" + recentlyViewedHandles[i] + "?view=grid-xhr", function(data) {
        $destination.append(data);
      });
    }, i * 50);
  }
};
vsp.randomProductsFromCollection = function() {
  var $el = jQuery(".random-products-from-collection");
  if (!$el.length) {
    return;
  }
  jQuery.ajax({ type: "GET", url: $el.attr("data-url") }).then(function(itemHTML) {
    var $items2 = $("<div/>").html(itemHTML).find(".items").children();
    var shuffledItems = shuffle($items2);
    $el.find(".item-grid").append(shuffledItems.slice(0, 5));
    $el.addClass("visible");
  });
};
vsp.relatedProducts = function() {
  var fetchRelatedProductHTML = function(object, url) {
    return jQuery.ajax({ type: "GET", url }).then(function(itemHTML) {
      var items = $("<div/>").html(itemHTML).find(".items").children();
      object.itemHTML = items;
    });
  };
  if (vsp.relatedProductData && vsp.relatedProductData.length) {
    var requestPromises = [];
    for (var i = 0; i < vsp.relatedProductData.length; i++) {
      requestPromises.push(fetchRelatedProductHTML(vsp.relatedProductData[i], vsp.relatedProductData[i].url));
    }
  }
  ;
  $.when.apply($, requestPromises).then(function() {
    vsp.displayRelatedProducts(vsp.relatedProductData);
  });
};
vsp.displayRelatedProducts = function(data) {
  var maxItemsToDisplay = 5;
  var $relatedProducts = $(".related-products");
  $relatedProducts.addClass("visible");
  var filterString = ".item-grid-item:not(.sold-item):not([data-item-handle='" + vsp.currentItemHandle + "'])";
  if (data && data[0] && data[0].mensItem) {
    filterString = filterString + ".mens-item";
  } else {
    filterString = filterString + ":not(.mens-item)";
  }
  for (var i = 0; i < data.length; i++) {
    var thisData = data[i];
    thisData.items = $(thisData.itemHTML).filter(filterString);
  }
  for (var i = 0; i < data.length; i++) {
    var thisData = data[i], items = thisData.items.sort(function() {
      return 0.5 - Math.random();
    }).slice(0, maxItemsToDisplay);
    if (items && items.length) {
      var $set = $('<div class="related-product-set visible secondary-product-set" data-type="' + thisData.type + '"><h3>' + thisData.label + "</h3></div>"), $grid2 = $('<div class="item-grid visible"></div>');
      $grid2.append($(items));
      $set.append($grid2);
      $set.append("<a class='styled-button small' href='" + thisData.viewMoreLink + "'>" + thisData.viewMoreLabel + "</a>");
      $relatedProducts.append($set);
    }
  }
  if (vsp.lazyLoadInstance) {
    vsp.lazyLoadInstance.update();
  }
};
vsp.getHash = function() {
  return window.location.hash;
};
vsp.hideImageLightbox = function(event) {
  $("body").removeAttr("data-visible-overlay");
  setTimeout(function() {
    $(".image-overlay .overlay-inner").empty();
  }, 300);
  vsp.lightboxImages = vsp.lightboxIndex = null;
  $(document).off("keydown.imageLightbox", vsp.imageLightboxKeyHandler);
};
vsp.showImageLightbox = function(event) {
  if ($(window).width() <= 768) {
    event.preventDefault();
    return false;
  }
  event.preventDefault();
  var $linkElement = $(event.currentTarget), $allLinks = $linkElement.closest(".item-photos").find(".lightbox-link:not(.slick-cloned)").clone();
  srcAttribute = $linkElement.find("img")[0].currentSrc || $linkElement.attr("href"), srcSetAttribute = $linkElement.find("img").attr("srcset"), clickedIndex = $linkElement.attr("data-index");
  vsp.lightboxImages = $allLinks.find(".product-image, .product-video");
  vsp.lightboxIndex = $allLinks.index($linkElement);
  $(".image-overlay .photo-counter span.curent").text(1);
  $(".image-overlay .photo-counter span.total").text(vsp.lightboxImages.length);
  $(".image-overlay .overlay-inner").append(vsp.lightboxImages.clone());
  $(".image-overlay").toggleClass("single-image", $allLinks.length < 2);
  setTimeout(function() {
    $(".image-overlay .overlay-inner img").each((index2, el) => {
      el.setAttribute("sizes", "100vw");
    });
  }, 1);
  vsp.showOverlay("image-overlay");
  if (clickedIndex != 0) {
    $(".image-overlay .overlay-inner").find("img, video")[clickedIndex].scrollIntoView();
  }
  $(document).on("keydown.imageLightbox", vsp.imageLightboxKeyHandler);
};
vsp.imageLightboxKeyHandler = function(event) {
  if (event.which == 37) {
  }
  if (event.which == 39) {
  }
  if (event.which == 27) {
    vsp.hideImageLightbox();
  }
};
vsp.RECENT_SEARCHES_KEY = "vsp.recentSearches";
vsp.RECENT_SEARCHES_MAX = 10;
vsp.RECENT_SEARCHES_SHOWN = 5;
vsp.SEARCH_GENDER_KEY = "vsp.searchGender";
try {
  localStorage.removeItem(vsp.SEARCH_GENDER_KEY);
} catch (e) {
}
vsp.SEARCH_GENDER_DEFAULT = "all";
vsp.SEARCH_DEPARTMENT_FILTER_PARAM = "filter.p.m.filterable.department";
vsp.SEARCH_DEPARTMENT_VALUES = {
  women: "Women",
  mens: "Men"
};
vsp.getSearchGender = function() {
  if (vsp.searchGenderForView) return vsp.searchGenderForView;
  try {
    return sessionStorage.getItem(vsp.SEARCH_GENDER_KEY) || vsp.SEARCH_GENDER_DEFAULT;
  } catch (e) {
    return vsp.SEARCH_GENDER_DEFAULT;
  }
};
vsp.setSearchGender = function(gender) {
  vsp.searchGenderForView = gender;
  try {
    sessionStorage.setItem(vsp.SEARCH_GENDER_KEY, gender);
  } catch (e) {
  }
};
vsp.syncSearchGenderToggle = function() {
  $(".search-gender-toggle button").removeClass("active").filter("[data-search-gender='" + vsp.getSearchGender() + "']").addClass("active");
};
vsp.searchGenderFromURL = function() {
  var department = new URLSearchParams(window.location.search).get(vsp.SEARCH_DEPARTMENT_FILTER_PARAM);
  var gender = "all";
  Object.keys(vsp.SEARCH_DEPARTMENT_VALUES).forEach(function(key) {
    if (vsp.SEARCH_DEPARTMENT_VALUES[key] === department) gender = key;
  });
  return gender;
};
vsp.searchQueryString = function(term) {
  var query = "type=product&q=" + encodeURIComponent(term);
  var department = vsp.SEARCH_DEPARTMENT_VALUES[vsp.getSearchGender()];
  if (department) {
    query += "&" + vsp.SEARCH_DEPARTMENT_FILTER_PARAM + "=" + encodeURIComponent(department);
  }
  return query;
};
vsp.updateSearchURL = function(term) {
  var url = "/search?" + vsp.searchQueryString(term);
  if (vsp.searchPageMode || vsp.searchHistoryPushed) {
    history.replaceState({ vspSearch: true }, "", url);
  } else {
    history.pushState({ vspSearch: true }, "", url);
    vsp.searchHistoryPushed = true;
  }
};
vsp.getRecentSearches = function() {
  try {
    var raw = localStorage.getItem(vsp.RECENT_SEARCHES_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};
vsp.RECENT_SEARCH_SETTLE_MS = 1500;
vsp.scheduleRecentSearchSave = function(term) {
  clearTimeout(vsp.recentSearchSettleTimer);
  if (term.length < 3) return;
  vsp.recentSearchSettleTimer = setTimeout(function() {
    vsp.saveRecentSearch(term);
    vsp.renderRecentSearches();
  }, vsp.RECENT_SEARCH_SETTLE_MS);
};
vsp.saveRecentSearch = function(term) {
  var termLower = term.toLowerCase();
  var searches = vsp.getRecentSearches().filter(function(saved) {
    return saved.toLowerCase() !== termLower;
  });
  if (searches.length && termLower.indexOf(searches[0].toLowerCase()) === 0) {
    searches.shift();
  }
  searches.unshift(term);
  if (searches.length > vsp.RECENT_SEARCHES_MAX) searches.length = vsp.RECENT_SEARCHES_MAX;
  try {
    localStorage.setItem(vsp.RECENT_SEARCHES_KEY, JSON.stringify(searches));
  } catch (e) {
  }
};
vsp.renderRecentSearches = function() {
  var $containers = $(".search-recent");
  if (!$containers.length) return;
  var searches = vsp.getRecentSearches().slice(0, vsp.RECENT_SEARCHES_SHOWN);
  $containers.find("ul").each(function() {
    var $list = $(this).empty();
    searches.forEach(function(term) {
      $("<li>").append(
        $("<a class='popular-search-term'>").attr("data-term", term).attr("href", "/search?type=product&q=" + encodeURIComponent(term)).text(term)
      ).appendTo($list);
    });
  });
  $containers.attr("data-empty", searches.length === 0 ? "true" : "false");
};
vsp.SEARCH_MEN_TITLE_PATTERN = /\bmen(['’]?s|swear)?\b/i;
vsp.SEARCH_WOMEN_TITLE_PATTERN = /\bwom[ae]n(['’]?s|swear)?\b/i;
vsp.collectionTitleFitsSearchGender = function(title) {
  var gender = vsp.getSearchGender();
  if (gender === "all") return true;
  var mentionsMen = vsp.SEARCH_MEN_TITLE_PATTERN.test(title || "");
  var mentionsWomen = vsp.SEARCH_WOMEN_TITLE_PATTERN.test(title || "");
  if (gender === "women") return !(mentionsMen && !mentionsWomen);
  return !(mentionsWomen && !mentionsMen);
};
vsp.doPredictiveSearch = function(term) {
  if (vsp.runningPredictiveRequest) {
    vsp.runningPredictiveRequest.abort();
  }
  var $collections = $(".search-overlay .search-collections");
  var $suggestions = $(".search-overlay .search-suggestions");
  if (!$collections.length && !$suggestions.length) return;
  vsp.runningPredictiveRequest = $.get(
    "/search/suggest?q=" + encodeURIComponent(term) + "&resources[type]=collection,query&resources[limit]=10&section_id=predictive-search"
  ).done(function(html) {
    var $rendered = $("<div>").html(html);
    var $collectionItems = $rendered.find("[data-predictive-collections] > li").filter(function() {
      return vsp.collectionTitleFitsSearchGender($(this).find("a").attr("data-title"));
    });
    $collections.find("ul").empty().append($collectionItems);
    $collections.toggle($collectionItems.length > 0);
    var $queryItems = $rendered.find("[data-predictive-queries] > li");
    $suggestions.find("ul").empty().append($queryItems);
    $suggestions.toggle($queryItems.length > 0);
  }).fail(function(xhr, status) {
    if (status === "abort") return;
    $collections.hide().find("ul").empty();
    $suggestions.hide().find("ul").empty();
  });
};
vsp.doLiveSearch = function(event) {
  var $input = $(event.target);
  var $form = $input.closest("form");
  var term = $input.val().trim();
  $form.attr("data-populated", term.length > 0);
  var $searchWrap = $form.closest(".search-wrap");
  var $searchResults = $searchWrap.find(".search-results");
  $searchWrap.attr("data-populated", term.length > 0);
  if (vsp.lastSearchedTerm === term) {
    return false;
  }
  vsp.lastSearchedTerm = term;
  clearTimeout(vsp.recentSearchSettleTimer);
  clearTimeout(vsp.searchAnalyticsTimer);
  if (vsp.runningLiveSearchRequest) {
    vsp.runningLiveSearchRequest.abort();
  }
  if (term.length === 0) {
    vsp.resetLiveSearch($searchWrap);
    return;
  }
  vsp.doPredictiveSearch(term);
  $searchResults.empty().append("<div class='loader'></div>").addClass("with-loader");
  vsp.updateSearchURL(term);
  vsp.runningLiveSearchRequest = $.ajax("/search?view=nolayout&" + vsp.searchQueryString(term)).done(function(result) {
    $searchResults.replaceWith(result);
    $searchResults = $searchWrap.find(".search-results");
    if (window.swat) {
      vsp.itemGridWishlist(window.swat);
    }
    vsp.grid();
    var noResults = $searchResults.find(".empty-search-results").length > 0;
    if (noResults) {
      vsp.annotateEmptySearchDepartment($searchResults.find(".empty-search-results"));
      vsp.emptySearchResults($searchResults.find(".empty-search-results"), term);
    } else {
      vsp.scheduleRecentSearchSave(term);
    }
    var countMatch = noResults ? null : $searchResults.text().match(/found the following (\d+) products/);
    vsp.scheduleSearchAnalytics(term, noResults ? 0 : countMatch ? Number(countMatch[1]) : "");
  }).fail(function(xhr, status) {
    if (status === "abort") return;
    $searchResults.removeClass("with-loader").empty().append(
      $("<div class='empty-search-results search-error'>").append(
        $("<h4 class='page-title'>").text("Search didn't load. ").append(
          $("<a href='#' class='search-retry'>").text("Try again")
        )
      )
    );
  });
};
vsp.SEARCH_DEPARTMENT_LABELS = { women: "Women's", mens: "Men's" };
vsp.annotateEmptySearchDepartment = function($emptyResults) {
  var departmentLabel = vsp.SEARCH_DEPARTMENT_LABELS[vsp.getSearchGender()];
  if (!departmentLabel || !$emptyResults.length || $emptyResults.find("[data-search-all-departments]").length) return;
  var $heading = $emptyResults.find("h4").first();
  $heading.text($heading.text().replace(/had no results\.?$/, "had no results in " + departmentLabel + "."));
  var term = $emptyResults.closest(".search-wrap").find(".search-form-input:visible").val() || "";
  $heading.after(
    $("<p class='search-all-departments'>").append(
      $("<a data-search-all-departments>").attr("href", "/search?type=product&q=" + encodeURIComponent(term.trim())).text("Search all departments")
    )
  );
};
vsp.scheduleSearchAnalytics = function(term, resultCount) {
  clearTimeout(vsp.searchAnalyticsTimer);
  vsp.searchAnalyticsTimer = setTimeout(function() {
    var details = { search_query: term, department: vsp.getSearchGender(), result_count: resultCount };
    vsp.logAnalyticsEvent("search_performed", details);
    if (resultCount === 0) vsp.logAnalyticsEvent("search_no_results", details);
    vsp.logSearchRequery(term);
    vsp.markClaritySession("used_search");
  }, vsp.RECENT_SEARCH_SETTLE_MS);
};
vsp.emptySearchResults = function(resultsEl, searchTerm) {
  vsp.setupBrandSuggestions().then(function() {
    var brandSuggestions = vsp.getBrandSuggestionForString(searchTerm);
    if (brandSuggestions && brandSuggestions.length) {
      var $suggestion = $("<p>Did you mean </p>");
      $suggestion.append("<a href='" + brandSuggestions[0].item.brandURL + "'>" + brandSuggestions[0].item.brandName + "</a>");
      if (brandSuggestions.length > 1) {
        $suggestion.append(" or <a href='" + brandSuggestions[1].item.brandURL + "'>" + brandSuggestions[1].item.brandName + "</a>");
      }
      $suggestion.append("?");
      resultsEl.find("h4").after($suggestion);
    }
  });
};
vsp.resetLiveSearch = function($searchWrap) {
  if (vsp.runningLiveSearchRequest) vsp.runningLiveSearchRequest.abort();
  if (vsp.runningPredictiveRequest) vsp.runningPredictiveRequest.abort();
  clearTimeout(vsp.recentSearchSettleTimer);
  clearTimeout(vsp.searchAnalyticsTimer);
  vsp.lastSearchedTerm = "";
  $searchWrap.attr("data-populated", false);
  $searchWrap.find("form").attr("data-populated", false);
  $searchWrap.find(".search-results").empty().removeClass("with-loader");
  $searchWrap.find(".search-collections, .search-suggestions").hide().find("ul").empty();
  if (vsp.searchPageMode) {
    history.replaceState({}, "", "/search");
  } else if (vsp.preOverlayURL) {
    history.replaceState({}, "", vsp.preOverlayURL);
  }
};
vsp.logAnalyticsEvent = function(eventName, details) {
  details = details || {};
  if (/^(search_|popular_search_)/.test(eventName)) {
    details.search_back_mode = vsp.SEARCH_LEAVE_OVERLAY_HISTORY_ON_CLICK ? "leave" : "results";
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({ event: eventName }, details));
  var attempts = 0;
  (function sendToClarity() {
    if (typeof window.clarity === "function") {
      window.clarity("event", eventName);
      Object.keys(details).forEach(function(key) {
        if (details[key] !== "") window.clarity("set", key, String(details[key]));
      });
    } else if (attempts++ < 20) {
      setTimeout(sendToClarity, 500);
    }
  })();
};
vsp.trackSoldOutContinueShopping = function() {
  var $pageButton = $(".item-view .shop-product-type-button").first();
  if ($pageButton.length) {
    vsp.logAnalyticsEvent("sold_out_product_view", { product_type: $pageButton.attr("data-product-type") || "" });
  }
  $("body").on("click", ".shop-product-type-button", function() {
    vsp.logAnalyticsEvent("sold_out_continue_shopping", { product_type: $(this).attr("data-product-type") || "" });
  });
};
vsp.trackSearchSidebar = function() {
  var eventsBySelector = [
    [".search-recent a", "search_recent_search_click", function(element) {
      return { search_term: element.getAttribute("data-term") || element.textContent.trim() };
    }],
    [".search-sidebar .search-collections a", "search_collection_click", function(element) {
      return { collection: element.getAttribute("data-title") || element.textContent.trim() };
    }],
    [".search-sidebar .search-suggestions a", "search_suggestion_click", function(element) {
      return { search_term: element.getAttribute("data-term") || element.textContent.trim() };
    }],
    [".search-gender-toggle button", "search_department_toggle", function(element) {
      return { department: element.getAttribute("data-search-gender") || "" };
    }]
  ];
  document.addEventListener("click", function(event) {
    eventsBySelector.forEach(function(entry) {
      var element = event.target.closest && event.target.closest(entry[0]);
      if (!element) return;
      var input = $(element).closest(".search-wrap").find(".search-form-input:visible")[0];
      var details = entry[2](element);
      details.search_query = input ? input.value.trim() : "";
      vsp.logAnalyticsEvent(entry[1], details);
    });
  }, true);
};
vsp.SEARCH_LEAVE_OVERLAY_HISTORY_ON_CLICK = false;
vsp.markClaritySession = function(tagName) {
  var attempts = 0;
  (function setTag() {
    if (typeof window.clarity === "function") {
      window.clarity("set", tagName, "yes");
    } else if (attempts++ < 20) {
      setTimeout(setTag, 500);
    }
  })();
};
vsp.SEARCH_RESULT_CLICKS_KEY = "vsp.searchResultClicks";
vsp.LAST_SEARCH_RESULT_CLICK_KEY = "vsp.lastSearchResultClick";
vsp.SEARCH_REQUERY_WINDOW_MS = 10 * 60 * 1e3;
vsp.SEARCH_BACK_LANDING_WINDOW_MS = 30 * 60 * 1e3;
vsp.readSessionJSON = function(key, fallback) {
  try {
    return JSON.parse(sessionStorage.getItem(key)) || fallback;
  } catch (error) {
    return fallback;
  }
};
vsp.writeSessionJSON = function(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
  }
};
vsp.recordSearchResultClick = function(query, product) {
  var queryKey = query.toLowerCase();
  var clicksByQuery = vsp.readSessionJSON(vsp.SEARCH_RESULT_CLICKS_KEY, {});
  var products = clicksByQuery[queryKey] || [];
  if (products.indexOf(product) === -1) products.push(product);
  clicksByQuery[queryKey] = products;
  vsp.writeSessionJSON(vsp.SEARCH_RESULT_CLICKS_KEY, clicksByQuery);
  vsp.writeSessionJSON(vsp.LAST_SEARCH_RESULT_CLICK_KEY, { query, product, at: Date.now() });
  return products.indexOf(product) + 1;
};
vsp.logSearchRequery = function(term) {
  var lastClick = vsp.readSessionJSON(vsp.LAST_SEARCH_RESULT_CLICK_KEY, null);
  if (!lastClick || lastClick.requeried) return;
  var elapsedMs = Date.now() - lastClick.at;
  if (elapsedMs > vsp.SEARCH_REQUERY_WINDOW_MS) return;
  if (term.trim().toLowerCase() !== lastClick.query.toLowerCase()) return;
  lastClick.requeried = true;
  vsp.writeSessionJSON(vsp.LAST_SEARCH_RESULT_CLICK_KEY, lastClick);
  vsp.logAnalyticsEvent("search_requery", { search_query: term, product: lastClick.product, minutes_since_click: Math.round(elapsedMs / 6e3) / 10 });
};
vsp.trackSearchBackLanding = function() {
  window.addEventListener("pageshow", function(event) {
    var lastClick = vsp.readSessionJSON(vsp.LAST_SEARCH_RESULT_CLICK_KEY, null);
    if (!lastClick || lastClick.landed) return;
    if (Date.now() - lastClick.at > vsp.SEARCH_BACK_LANDING_WINDOW_MS) return;
    var navigationEntry = performance.getEntriesByType ? performance.getEntriesByType("navigation")[0] : null;
    var isHistoryTraversal = event.persisted || navigationEntry && navigationEntry.type === "back_forward";
    var productHandle = $("main[data-product-handle]").attr("data-product-handle");
    if (productHandle === lastClick.product) {
      if (!isHistoryTraversal && !lastClick.reachedProduct) {
        lastClick.reachedProduct = true;
        vsp.writeSessionJSON(vsp.LAST_SEARCH_RESULT_CLICK_KEY, lastClick);
      }
      return;
    }
    if (!isHistoryTraversal || !lastClick.reachedProduct) return;
    lastClick.landed = true;
    vsp.writeSessionJSON(vsp.LAST_SEARCH_RESULT_CLICK_KEY, lastClick);
    vsp.logAnalyticsEvent("search_back_landing", {
      search_query: lastClick.query,
      product: lastClick.product,
      landing: window.location.pathname === "/search" ? "search_results" : "previous_page",
      page: window.location.pathname
    });
  });
};
vsp.cartAnalyticsDetails = function(source) {
  var root = source === "page" ? document.querySelector("main") : vsp.cartDrawer || document.querySelector("cart-drawer");
  var container = root && root.querySelector(".cart-wrap, .empty-cart");
  if (!container) return null;
  var finalSaleCount = container.querySelectorAll(".full-cart-item .final-sale-warning").length;
  return {
    item_count: container.querySelectorAll(".full-cart-item").length,
    final_sale_count: finalSaleCount,
    final_sale: finalSaleCount ? "yes" : "no"
  };
};
vsp.logCartView = function(source) {
  var details = vsp.cartAnalyticsDetails(source === "page" ? "page" : "drawer");
  if (!details) return;
  details.source = source;
  vsp.logAnalyticsEvent("cart_view", details);
};
vsp.trackCart = function() {
  if (document.querySelector("main .cart-wrap, main .empty-cart")) vsp.logCartView("page");
};
vsp.WISHLIST_UNAVAILABLE_AFTER_MS = 8e3;
vsp.wishlistProductHandle = function(url) {
  var match = /\/products\/([^/?#]+)/.exec(url || "");
  return match ? match[1] : "";
};
vsp.wishlistSource = function(element) {
  var $element = $(element);
  var inDrawer = $element.closest("cart-drawer").length > 0;
  if ($element.closest("[data-cart-view-panel='wishlist']").length) return inDrawer ? "cart_drawer_wishlist" : "cart_page_wishlist";
  if ($element.closest(".wishlist-display").length) return "wishlist_page";
  if ($element.closest(".full-cart-item").length) return inDrawer ? "cart_drawer" : "cart_page";
  return "product_page";
};
vsp.logWishlistEvent = function(eventName, details) {
  vsp.logAnalyticsEvent(eventName, details);
  vsp.markClaritySession("used_wishlist");
};
vsp.trackWishlistAvailability = function() {
  var page = document.querySelector("#wishlist-actions-template") ? "product_page" : document.querySelector(".wishlist-display[data-type]:not([data-cart-wishlist-display])") ? "wishlist_page" : "";
  if (!page) return;
  var check = function() {
    setTimeout(function() {
      if (window.swat) return;
      vsp.logAnalyticsEvent("wishlist_unavailable", {
        page,
        consent_api: window.Shopify && window.Shopify.customerPrivacy ? "yes" : "no",
        signed_in: document.body.classList.contains("customer-logged-in") ? "yes" : "no"
      });
    }, vsp.WISHLIST_UNAVAILABLE_AFTER_MS);
  };
  if (document.readyState === "complete") check();
  else window.addEventListener("load", check);
};
vsp.trackSiteEvents = function() {
  var text = function(element) {
    return element ? element.textContent.replace(/\s+/g, " ").trim() : "";
  };
  var positionIn = function(element, siblingSelector) {
    var item2 = element.closest(siblingSelector);
    if (!item2 || !item2.parentElement) return "";
    return Array.prototype.indexOf.call(item2.parentElement.children, item2) + 1;
  };
  var searchQuery = function(element) {
    var input = $(element).closest(".search-wrap").find(".search-form-input:visible")[0];
    return input ? input.value.trim() : "";
  };
  var logHeroView = function() {
    var $hero = $(".home-banner-section").filter(":visible").first();
    if ($hero.length) {
      vsp.logAnalyticsEvent("hero_view", { hero: text($hero.find(".home-banner-title")[0]) || $hero.attr("id") || "" });
    }
  };
  if (document.readyState === "complete") logHeroView();
  else window.addEventListener("load", logHeroView);
  var events = [
    [".search-results .item-grid-item a:not(.quick-view-button-wrapper)", function(element) {
      var query = searchQuery(element);
      var product = element.closest(".item-grid-item").getAttribute("data-item-handle") || "";
      return ["search_result_click", { search_query: query, product, position: positionIn(element, ".item-grid-item"), click_index: vsp.recordSearchResultClick(query, product) }];
    }],
    [".search-featured-list a", function(element) {
      return ["popular_search_tile_click", { tile: text(element.querySelector(".search-featured-item-label")) || element.getAttribute("data-term") || "", position: positionIn(element, ".search-featured-list > li") }];
    }],
    [".home-banner", function(element) {
      var section = element.closest(".home-banner-section");
      return ["hero_click", { hero: text(element.querySelector(".home-banner-title")) || section && section.id || "" }];
    }],
    [".desktop-nav-left .desktop-nav-left-link, .desktop-nav-left .desktop-nav-left-shop-all, .desktop-nav-left .desktop-nav-left-tab, .desktop-nav-left .desktop-nav-left-group-heading a", function(element) {
      var tabItem = element.closest(".desktop-nav-left-tab-item");
      var group = element.closest(".desktop-nav-left-group");
      return ["nav_link_click", { tab: text(tabItem && tabItem.querySelector(".desktop-nav-left-tab")), group: text(group && group.querySelector(".desktop-nav-left-group-heading")), link: text(element) }];
    }],
    [".home-collections-item", function(element) {
      return ["category_tile_click", { tile: text(element.querySelector(".home-collections-item-label")), position: positionIn(element, ".home-collections-item") }];
    }],
    [".homepage-grid-block", function(element) {
      return ["home_grid_click", { block: text(element.querySelector(".homepage-grid-block-title")) }];
    }],
    [".quick-view-button-wrapper", function(element) {
      return ["quick_view_open", { product: (element.closest(".item-grid-item") || element).getAttribute("data-item-handle") || "" }];
    }],
    [".size-guide-link", function(element) {
      return ["size_guide_open", { size: element.getAttribute("data-generic-size") || "", product_type: document.body.getAttribute("data-product-type") || "" }];
    }],
    [".full-cart-form input[name='checkout']", function(element) {
      return ["checkout_click", vsp.cartAnalyticsDetails(element.closest("cart-drawer") ? "drawer" : "page") || {}];
    }],
    [".full-cart-item .cart__remove, .full-cart-item .move-cart-item-to-wishlist", function(element) {
      var item2 = element.closest(".full-cart-item");
      var link = item2.querySelector("a[href*='/products/']");
      return ["cart_item_removed", {
        action: element.classList.contains("cart__remove") ? "remove" : "wishlist",
        product: link ? link.getAttribute("href").split("/products/")[1].split(/[?#]/)[0] : "",
        final_sale: item2.querySelector(".final-sale-warning") ? "yes" : "no"
      }];
    }]
  ];
  document.addEventListener("click", function(event) {
    if (!event.target.closest) return;
    events.forEach(function(entry) {
      var element = event.target.closest(entry[0]);
      if (!element) return;
      var result = entry[1](element);
      vsp.logAnalyticsEvent(result[0], result[1]);
    });
  }, true);
  $(document).one("mouseenter focusin", ".desktop-nav-left-tab", function() {
    vsp.markClaritySession("used_new_menu");
  });
};
vsp.setupLiveSearch = function() {
  var $searchPage = $(".search-overlay--page");
  vsp.searchPageMode = $searchPage.length > 0;
  $("a[href='/search']:not(.active").on("click", function(event) {
    event.preventDefault();
    if (vsp.searchPageMode) {
      window.scrollTo(0, 0);
      $searchPage.find(".search-form-input:visible").focus();
      return;
    }
    vsp.showOverlay("search");
  });
  $(".search-form").on("keyup change", ".search-form-input", $.debounce(100, vsp.doLiveSearch));
  $(".search-form").on("submit", function(event) {
    event.preventDefault();
    var $input = $(event.target).find(".search-form-input:visible");
    var term = $input.val().trim();
    if (term.length >= 3) {
      vsp.saveRecentSearch(term);
    }
    vsp.doLiveSearch({ target: $input[0] });
  });
  $("body").on("click", ".search-retry", function(event) {
    event.preventDefault();
    vsp.lastSearchedTerm = null;
    $(this).closest(".search-wrap").find(".search-form-input:visible").trigger("change");
  });
  if (vsp.searchPageMode) {
    vsp.annotateEmptySearchDepartment($searchPage.find(".empty-search-results"));
  }
  $("body").on("click", "[data-search-all-departments]", function(event) {
    var $allButton = $(this).closest(".search-wrap").find('.search-gender-toggle button[data-search-gender="all"]');
    if (!$allButton.length) return;
    event.preventDefault();
    $allButton.trigger("click");
  });
  $("body").on("click", ".search-gender-toggle button", function() {
    vsp.setSearchGender($(this).attr("data-search-gender"));
    vsp.syncSearchGenderToggle();
    vsp.lastSearchedTerm = null;
    var $input = $(this).closest(".search-wrap").find(".search-form-input:visible");
    if ($input.val().trim().length > 0) {
      $input.trigger("change");
    }
  });
  window.addEventListener("popstate", function() {
    if (vsp.visibleOverlay === "search" && vsp.searchHistoryPushed) {
      vsp.searchHistoryPushed = false;
      vsp.hideOverlay();
    }
  });
  document.addEventListener("click", function(event) {
    if (!vsp.SEARCH_LEAVE_OVERLAY_HISTORY_ON_CLICK) return;
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (vsp.visibleOverlay !== "search" || !vsp.searchHistoryPushed) return;
    var link = event.target.closest && event.target.closest(".search-overlay a[href]");
    if (!link || link.target && link.target !== "_self") return;
    var destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin) return;
    event.preventDefault();
    window.location.replace(destination.href);
  });
  if (vsp.searchPageMode) {
    var initialTerm = ($searchPage.find(".search-form-input:visible").val() || "").trim();
    vsp.searchGenderForView = initialTerm ? vsp.searchGenderFromURL() : null;
    vsp.syncSearchGenderToggle();
    vsp.renderRecentSearches();
    vsp.lastSearchedTerm = initialTerm;
    if (initialTerm) {
      vsp.doPredictiveSearch(initialTerm);
    }
  }
  $("body").on("click", ".search-results a", function() {
    var term = $(this).closest(".search-wrap").find(".search-form-input:visible").val();
    if (term && term.trim().length >= 3) {
      vsp.saveRecentSearch(term.trim());
    }
  });
};
vsp.loginUrlReturningTo = function(path) {
  return "/customer_authentication/login?return_to=" + encodeURIComponent(path);
};
vsp.loginForms = function() {
  function showRecoverPasswordForm() {
    vsp.cache.$recoverPasswordForm.show();
    vsp.cache.$customerLoginForm.hide();
  }
  function hideRecoverPasswordForm() {
    vsp.cache.$recoverPasswordForm.hide();
    vsp.cache.$customerLoginForm.show();
  }
  $(".show-password").on("click", (event) => {
    let $clicked = $(event.currentTarget);
    let $input = $clicked.closest(".input-wrap").find("input");
    $input.attr("type", "text");
  });
  $(".hide-password").on("click", (event) => {
    let $clicked = $(event.currentTarget);
    let $input = $clicked.closest(".input-wrap").find("input");
    $input.attr("type", "password");
  });
  vsp.cache.$recoverPasswordLink.on("click", function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });
  vsp.cache.$hideRecoverPasswordLink.on("click", function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });
  if (vsp.getHash() == "#recover") {
    showRecoverPasswordForm();
  }
  if ($("input[name='return_to']").length) {
    const params = new URLSearchParams(window.location.search);
    const returnTo = params.get("return_to");
    if (returnTo && returnTo.length) {
      $("input[name='return_to']")[0].value = returnTo;
    }
  }
};
vsp.resetPasswordSuccess = function() {
  vsp.cache.$passwordResetSuccess.show();
};
vsp.randomNumberWithin = function(max) {
  return Math.floor(Math.random() * (max - 1));
};
vsp.blogArticle = function() {
  $.ajax({
    url: "/blogs/news?view=xhr",
    dataType: "html",
    complete: function(jqXHR, status) {
      var items;
      if (status === "success") {
        $response = $("<div>").html(jqXHR.responseText);
        var shuffledItems = shuffle($response.children().toArray());
        var attempts = added = 0;
        var currentId = $(".related-blog-posts").attr("data-current-article-id");
        while (added < 3 && attempts < 50) {
          var $item = $(shuffledItems.pop());
          attempts++;
          if ($item.attr("data-id") !== currentId) {
            added++;
            $(".related-blog-posts .blog-article-index-grid").append($item);
          }
        }
        $(".related-blog-posts").show();
      }
    }
  });
};
vsp.pages = function() {
  if ($(".main-page-section").length) {
    if ($(".main-page-section[data-hide-footer-border='true']").length) {
      $("#shopify-section-footer").addClass("no-border");
    }
    if ($(".main-page-section[data-transparent-header='true']").length) {
      $(".main-nav").attr("data-transparent", "true");
    }
  }
};
vsp.homepage = function() {
  vsp.homepageRandomItems();
  vsp.homepageProductItems();
  vsp.homepageIntroSection();
  vsp.enableHomepageScrollObserver();
  vsp.homepageSectionCount = $(".homepage-section").length;
  if ($("[data-is-intro-image='true']").length) {
    $("[data-is-intro-image='true']").closest(".shopify-section").addClass("shopify-section-intro-block");
    $("body").on("click", "[data-is-intro-image='true']", function(event) {
      var $clicked = $(event.currentTarget), bottom = $clicked.position().top + $clicked.offset().top + $clicked.outerHeight(true);
      $("html, body").animate({
        scrollTop: bottom + 16
      });
    });
  }
};
vsp.homepageIntroSection = function() {
  if (!$(".homepage-intro-section").length) {
    return false;
  }
  $("body").on("mouseover", ".homepage-intro-section a[data-index]", function(event) {
    var $link = $(event.currentTarget), $section = $link.closest(".shopify-section"), index2 = $link.attr("data-index");
    vsp.homepageIntroSectionShowItem($section, index2);
  });
  $(".homepage-intro-section").each(function() {
    var $section = $(this), autoAdvanceSpeedSeconds = ~~$section.find(".intro-items").attr("data-auto-advance-speed"), autoAdvanceSpeed = autoAdvanceSpeedSeconds * 1e3;
    setInterval(function() {
      index = ~~$section.find(".intro-items").attr("data-active-index"), total = $section.find(".intro-item-image-wrap").length, nextIndex = index + 1;
      if (nextIndex >= total) {
        nextIndex = 0;
      }
      vsp.homepageIntroSectionShowItem($section, nextIndex);
    }, autoAdvanceSpeed);
  });
};
vsp.homepageIntroSectionShowItem = function($section, index2) {
  $section.find(".intro-item-image-wrap").hide();
  $section.find(".intro-item-image-wrap[data-index='" + index2 + "']").show();
  $section.find(".intro-items").attr("data-active-index", index2);
  $section.find("a.active").removeClass("active");
  $section.find("a[data-index='" + index2 + "']").addClass("active");
};
vsp.homepageProductItems = function() {
  if (!$(".homepage-products-section").length) {
    return false;
  }
  $(".homepage-products-section .featured-products").slick({
    // accessibility: false,
    dots: false,
    arrows: true,
    slidesToShow: 5,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2e3,
    // slidesToShow: 1,
    // slide: "img",
    // mobileFirst: true,
    responsive: [
      {
        breakpoint: 600,
        settings: "unslick"
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
};
vsp.homepageRandomItems = function() {
  if (!$(".featured-items").length) {
    return false;
  }
  var viewportHeight = $(window).height(), $container = $(".featured-items"), $items2 = $container.find(".featured-item"), containerWidth = $container.width(), containerHeight = $container.height(), itemHeight = viewportHeight * 0.33, itemWidth = itemHeight * 0.66, rects = [], failures = 0, maxFailures = 300;
  $items2.hide();
  while (rects.length < $items2.length && failures < maxFailures) {
    var left = vsp.randomNumberWithin(containerWidth - itemWidth), top = vsp.randomNumberWithin(containerHeight - itemHeight), leftPercentage = left / containerWidth * 100 + "%", topPercentage = top / containerHeight * 100 + "%", potentialRect = {
      left,
      top,
      right: left + itemWidth,
      bottom: top + itemHeight,
      leftPercentage,
      topPercentage
    }, collides = false;
    for (var j = 0; j < rects.length && !collides; j++) {
      var otherRect = rects[j];
      collides = vsp.checkRectIntersection(potentialRect, otherRect);
    }
    if (!collides) {
      rects.push(potentialRect);
    } else {
      failures++;
    }
  }
  for (var j = 0; j < rects.length; j++) {
    var rect = rects[j];
    $items2.eq(j).css({
      left: rect.leftPercentage,
      top: rect.topPercentage,
      position: "absolute"
    }).show();
  }
  $(".featured-items").css({ opacity: 1 });
};
vsp.checkRectIntersection = function(rect1, rect2) {
  var buffer = 20;
  var intersecting = !(rect2.left > rect1.right + buffer || rect2.right + buffer < rect1.left || rect2.top > rect1.bottom + buffer || rect2.bottom + buffer < rect1.top);
  return intersecting;
};
vsp.handleHomepageScrollObserver = function(entries, observer) {
  if (window.innerWidth <= vsp.desktopAbove) {
    return false;
  }
  entries.forEach(function(entry) {
    var id = entry.target.getAttribute("id");
    var ratio = entry.intersectionRect.height / entry.rootBounds.height;
    if (ratio > 0.5 && vsp.homepageSectionInView !== id) {
      var $section = $(entry.target);
      vsp.homepageSectionInView = id;
      vsp.$homepageSectionInView = $section;
      $(".homepage").toggleClass("at-end", $section.index() + 1 >= vsp.homepageSectionCount);
      var label = vsp.$homepageSectionInView.find(".homepage-section-title").text();
      $(".homepage-section-title.dynamic-title").fadeOut(function() {
        $(".homepage-section-title.dynamic-title").text(label);
        $(".homepage-section-title.dynamic-title").fadeIn();
      });
    }
  });
};
vsp.enableHomepageScrollObserver = function() {
  if (!window.IntersectionObserver) {
    window.enableScrollObserverWhenReady = true;
    setTimeout(function() {
      vsp.enableScrollObserver();
    }, 1e3);
    return false;
  }
  vsp.scrollObserver = new IntersectionObserver(vsp.handleHomepageScrollObserver, {
    threshold: [0.01, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 0.99, 1]
  });
  $(".homepage-section").each(function(index2, el) {
    vsp.scrollObserver.observe(el);
  });
  var label = $(".homepage-section").eq(0).find(".homepage-section-title").text();
  $(".homepage-section-title.fixed").text(label);
  setTimeout(function() {
    $(".homepage-sections").attr("data-scroll-observing", true);
  }, 500);
};
vsp.imageUnderHeader = function(entry, index2) {
  var isUnderHeader = entry.isIntersecting && entry.intersectionRect.top < 75 && entry.intersectionRect.bottom > 60;
};
vsp.enableHeaderColorScrollWatcher = function() {
  const options = {
    // rootMargin: "0% 0% 75% 0%",
    // threshold: 1.0
    // threshold: [0.01, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 0.99, 1]
  };
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry, index2) => {
    });
  }, options);
};
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector("summary");
    this.content = el.querySelector(".details-content");
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener("click", (e) => this.onClick(e));
  }
  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = "hidden";
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }
  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 250,
      easing: "ease-out"
    });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }
  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }
  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 250,
      easing: "ease-out"
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }
  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = "";
  }
}
document.querySelectorAll(".accordian-widget details").forEach((el) => {
  new Accordion(el);
});
vsp.newAccordions = function() {
};
vsp.updateWishlistCount = function(count) {
  $("[data-wishlist-count]").text(count);
  $("[data-wishlist-count-wrap]").prop("hidden", false);
};
vsp.setWishlistProducts = function(products) {
  vsp.wishlistProducts = products || [];
  vsp.updateWishlistCount(vsp.wishlistProducts.length);
};
vsp.getWishlistProductViewUrl = function(productUrl, view) {
  if (!productUrl) return null;
  try {
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set("view", view);
    return `${url.pathname}${url.search}`;
  } catch (error) {
    return null;
  }
};
vsp.extractWishlistCard = function(html, cartDisplay) {
  const selector = cartDisplay ? ".wishlist-cart-item" : ".item-grid-item";
  const nodes = jQuery.parseHTML(html, document, false) || [];
  const $response2 = $(nodes);
  return $response2.filter(selector).add($response2.find(selector)).first();
};
vsp.validateWishlistProducts = function(products) {
  const checks = (products || []).map(function(item2) {
    const statusUrl = vsp.getWishlistProductViewUrl(item2.du, "wishlist-status-xhr");
    if (!statusUrl) return Promise.resolve({ item: item2, keep: false });
    return Promise.resolve(jQuery.get(statusUrl)).then(function() {
      return { item: item2, keep: true };
    }, function(request) {
      return { item: item2, keep: !request || request.status !== 404 };
    });
  });
  return Promise.all(checks).then(function(results) {
    return results.filter(function(result) {
      return result.keep;
    }).map(function(result) {
      return result.item;
    });
  });
};
vsp.fetchWishlistProducts = function(swat) {
  if (Array.isArray(vsp.wishlistProducts)) {
    vsp.updateWishlistCount(vsp.wishlistProducts.length);
    return Promise.resolve(vsp.wishlistProducts);
  }
  if (vsp.wishlistProductsPromise) return vsp.wishlistProductsPromise;
  vsp.wishlistProductsPromise = new Promise(function(resolve, reject) {
    swat.fetch(function(products) {
      vsp.validateWishlistProducts(products).then(function(validProducts) {
        vsp.setWishlistProducts(validProducts);
        resolve(vsp.wishlistProducts);
      }).catch(function(error) {
        vsp.wishlistProductsPromise = null;
        reject(error);
      });
    }, function(error) {
      vsp.wishlistProductsPromise = null;
      reject(error);
    });
  });
  return vsp.wishlistProductsPromise;
};
vsp.addWishlistProductToCache = function(itemData) {
  if (!Array.isArray(vsp.wishlistProducts)) return;
  const alreadySaved = vsp.wishlistProducts.some(function(item2) {
    return parseInt(item2.epi, 10) === itemData.epi && parseInt(item2.empi, 10) === itemData.empi;
  });
  if (!alreadySaved) {
    vsp.setWishlistProducts(vsp.wishlistProducts.concat([itemData]));
  }
};
vsp.removeWishlistProductFromCache = function(itemData) {
  if (!Array.isArray(vsp.wishlistProducts)) return;
  vsp.setWishlistProducts(vsp.wishlistProducts.filter(function(item2) {
    return parseInt(item2.epi, 10) !== itemData.epi || parseInt(item2.empi, 10) !== itemData.empi;
  }));
};
vsp.wishlistDisplayHasItems = function($display) {
  return $display.find(".item-grid > *, .wishlist-cart-table > *").length > 0;
};
vsp.removeWishlistItemFromDisplays = function(itemData) {
  $(".wishlist-display").each(function() {
    const $display = $(this);
    const wasRendered = $display.find(".item-grid, .wishlist-cart-table").length > 0;
    $display.find(`.remove-from-wishlist[data-empi="${itemData.empi}"][data-epi="${itemData.epi}"]`).closest(".item-grid-item, .wishlist-cart-item").remove();
    if (wasRendered && !vsp.wishlistDisplayHasItems($display)) {
      vsp.setWishlistDisplayState($display, false);
    }
    if (wasRendered && vsp.renderWishlistSoldNotice) {
      vsp.renderWishlistSoldNotice($display);
    }
  });
  vsp.removeWishlistProductFromCache(itemData);
};
vsp.setWishlistDisplayState = function($destination, hasItems) {
  const $cartPanel = $destination.closest("[data-cart-view-panel='wishlist']");
  if ($cartPanel.length) {
    $destination.toggle(hasItems);
    $cartPanel.find(".visible-if-wishlist-populated").toggle(hasItems);
    $cartPanel.find(".visible-if-wishlist-empty").prop("hidden", hasItems).toggle(!hasItems);
  } else {
    $destination.toggle(hasItems);
    $(".visible-if-wishlist-populated").toggle(hasItems);
    $(".visible-if-wishlist-empty").toggle(!hasItems);
  }
};
vsp.renderWishlistSoldNotice = function($destination) {
  $destination.find(".wishlist-sold-notice").remove();
  const $soldItems = $destination.find(".wishlist-cart-item[data-wishlist-item-state='sold']");
  const soldCount = $soldItems.length;
  if (!soldCount) return;
  const verb = soldCount === 1 ? "is" : "are";
  const $notice = $(
    `<p class="wishlist-sold-notice">${soldCount} of your items ${verb} sold out.</p>`
  );
  $destination.find(".wishlist-cart-wrap").before($notice);
};
vsp.applyCartStateToWishlist = function($destination, cart) {
  const variantsInCart = cart.items.map(function(item2) {
    return item2.variant_id;
  });
  $destination.find(".add-to-cart, .move-wishlist-item-to-cart").each(function() {
    const variant = parseInt($(this).attr("data-epi"), 10);
    if (variantsInCart.includes(variant)) {
      $(this).width($(this).width()).text("In Bag").removeClass("add-to-cart move-wishlist-item-to-cart").addClass("in-cart").attr("href", "/cart");
    }
  });
};
vsp.markWishlistItemsInCart = function($destination) {
  jQuery.getJSON("/cart.js", function(cart) {
    vsp.applyCartStateToWishlist($destination, cart);
  });
};
vsp.preserveActiveCartWishlistPanel = function(scope, nextSection) {
  if (!scope || !nextSection || scope.dataset.cartView !== "wishlist") return;
  const currentPanel = scope.querySelector("[data-cart-view-panel='wishlist']");
  const nextPanel = nextSection.querySelector("[data-cart-view-panel='wishlist']");
  if (currentPanel && nextPanel) {
    nextPanel.replaceWith(currentPanel);
  }
};
vsp.refreshCartWishlistPage = function(scope, swat) {
  return fetch("/cart").then(function(response) {
    return response.text();
  }).then(function(responseText) {
    const responseHTML = document.createRange().createContextualFragment(responseText);
    const nextSection = responseHTML.querySelector("#shopify-section-main-cart");
    const currentSection = scope.querySelector("#shopify-section-main-cart");
    if (!nextSection || !currentSection) return;
    const cartWrap = nextSection.querySelector(".cart-wrap");
    vsp.updateCartCount(cartWrap ? cartWrap.getAttribute("data-cart-count") : 0);
    vsp.preserveActiveCartWishlistPanel(scope, nextSection);
    currentSection.replaceWith(nextSection);
    vsp.renderCartWishlistCounts(swat);
    vsp.cartWishlist(swat);
    vsp.cartWishlistViews(swat);
  });
};
vsp.bindWishlistDisplayActions = function(swat) {
  if (!swat) return;
  $("body").off("click.vspWishlistRemove", ".wishlist-display .remove-from-wishlist").on("click.vspWishlistRemove", ".wishlist-display .remove-from-wishlist", function(event) {
    event.preventDefault();
    const $clicked = $(event.currentTarget);
    const $wishlistItem = $clicked.closest(".item-grid-item, .wishlist-cart-item");
    const itemData = {
      du: $clicked[0].dataset.du,
      epi: parseInt($clicked[0].dataset.epi, 10),
      empi: parseInt($clicked[0].dataset.empi, 10)
    };
    $wishlistItem.css("opacity", "0.5");
    swat.removeFromWishList(itemData, function() {
      vsp.logWishlistEvent("wishlist_remove", { source: vsp.wishlistSource($clicked), product: vsp.wishlistProductHandle(itemData.du) });
      vsp.removeWishlistItemFromDisplays(itemData);
    }, function(error) {
      $wishlistItem.css("opacity", "1");
      alert(`There was an error removing the product from wishlist: ${error}`);
    });
  });
  $("body").off("click.vspWishlistAdd", ".wishlist-display .add-to-cart, .wishlist-display .move-wishlist-item-to-cart").on("click.vspWishlistAdd", ".wishlist-display .add-to-cart, .wishlist-display .move-wishlist-item-to-cart", function(event) {
    event.preventDefault();
    const $clicked = $(event.currentTarget);
    const $wishlistItem = $clicked.closest(".item-grid-item, .wishlist-cart-item");
    const moveToCart = $clicked.hasClass("move-wishlist-item-to-cart");
    const cartPageScope = $clicked.closest(".cart-wishlist-page")[0];
    const itemData = {
      du: $clicked[0].dataset.du,
      epi: parseInt($clicked[0].dataset.epi, 10),
      empi: parseInt($clicked[0].dataset.empi, 10)
    };
    $wishlistItem.css("opacity", "0.5");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        "id": itemData.epi,
        "quantity": 1
      },
      dataType: "json",
      success: function() {
        vsp.logWishlistEvent("wishlist_move_to_cart", {
          source: vsp.wishlistSource($clicked),
          product: vsp.wishlistProductHandle(itemData.du),
          kept_in_wishlist: moveToCart ? "no" : "yes"
        });
        const finish = function() {
          if (!moveToCart) {
            jQuery.getJSON("/cart.js", function(cart) {
              vsp.updateCartCount(cart.item_count);
              vsp.applyCartStateToWishlist($(".wishlist-display"), cart);
            });
          }
          $wishlistItem.css("opacity", "1");
          if (cartPageScope) {
            vsp.refreshCartWishlistPage(cartPageScope, swat);
            if (vsp.cartDrawer) vsp.cartDrawer.update();
          } else if (vsp.cartDrawer) {
            vsp.cartDrawer.updateAndShow();
          }
        };
        $clicked.width($clicked.width()).text("In Bag").removeClass("add-to-cart move-wishlist-item-to-cart").addClass("in-cart").attr("href", "/cart");
        if (moveToCart) {
          swat.removeFromWishList(itemData, function() {
            vsp.removeWishlistItemFromDisplays(itemData);
            finish();
          }, function() {
            finish();
            alert("The item was added to your bag, but could not be removed from your wishlist.");
          });
        } else {
          finish();
        }
      },
      error: function(data) {
        $wishlistItem.css("opacity", "1");
        alert(data.responseJSON && data.responseJSON.description ? data.responseJSON.description : "There was an error adding the item to your bag.");
      }
    });
  });
};
vsp.displayWishlist = function(swat, wishlistData, destination) {
  const $destination = destination ? $(destination) : $(".wishlist-display");
  const items = wishlistData || [];
  const cartDisplay = $destination.is("[data-cart-wishlist-display]");
  vsp.bindWishlistDisplayActions(swat);
  if (!items.length) {
    $destination.empty();
    vsp.setWishlistDisplayState($destination, false);
    return;
  }
  const $items2 = cartDisplay ? $('<div class="cart-wrap wishlist-cart-wrap"><div class="cart-table full-cart full table--responsive wishlist-cart-table"></div></div>').find(".wishlist-cart-table") : $('<div class="item-grid"></div>');
  const $displayLayout = cartDisplay ? $items2.parent() : $items2;
  $destination.empty().append($displayLayout);
  vsp.setWishlistDisplayState($destination, true);
  const requests = items.map(function(item2) {
    const productView = cartDisplay ? "wishlist-cart-xhr" : "grid-xhr-wishlist";
    const productViewUrl = vsp.getWishlistProductViewUrl(item2.du, productView);
    if (!productViewUrl) return Promise.resolve({ html: null, failed: true });
    return Promise.resolve(jQuery.get(productViewUrl)).then(function(html) {
      return { html, failed: false };
    }, function(request) {
      return { html: null, failed: !request || request.status !== 404 };
    });
  });
  Promise.all(requests).then(function(results) {
    let invalidResponse = false;
    results.forEach(function(result) {
      if (!result.html) return;
      const $card = vsp.extractWishlistCard(result.html, cartDisplay);
      if ($card.length) {
        $items2.append($card);
      } else {
        invalidResponse = true;
      }
    });
    if (!$items2.children().length) {
      if (invalidResponse || results.some(function(result) {
        return result.failed;
      })) {
        $destination.html("<p>There was an error loading your wishlist.</p>");
      } else {
        vsp.setWishlistDisplayState($destination, false);
      }
      return;
    }
    if (cartDisplay) vsp.renderWishlistSoldNotice($destination);
    vsp.markWishlistItemsInCart($destination);
  });
};
vsp.loadCartWishlist = function(swat, destination) {
  const $destination = $(destination);
  if (!swat || !$destination.length || $destination.attr("data-wishlist-loading") === "true" || $destination.attr("data-wishlist-loaded") === "true") return;
  $destination.attr("data-wishlist-loading", "true");
  vsp.fetchWishlistProducts(swat).then(function(allWishlistedProducts) {
    $destination.removeAttr("data-wishlist-loading").attr("data-wishlist-loaded", "true");
    vsp.displayWishlist(swat, allWishlistedProducts, $destination);
    if ($destination.attr("data-log-view-on-load") === "true") {
      $destination.removeAttr("data-log-view-on-load");
      vsp.logWishlistEvent("wishlist_view", { source: vsp.wishlistSource($destination), item_count: (allWishlistedProducts || []).length });
    }
  }).catch(function() {
    $destination.removeAttr("data-wishlist-loading").html("<p>There was an error loading your wishlist.</p>");
  });
};
vsp.setCartWishlistView = function(scope, view, swat) {
  const $scope = $(scope);
  if (!$scope.length) return;
  if ($scope.is("cart-drawer")) {
    $scope.find("[data-cart-view-panel='wishlist'] .styled-button").addClass("tiny");
  }
  $scope.attr("data-cart-view", view);
  $scope.find("[data-cart-view-trigger]").each(function() {
    const selected = this.dataset.cartViewTrigger === view;
    $(this).toggleClass("is-selected", selected).attr("aria-pressed", selected ? "true" : "false");
  });
  $scope.find("[data-cart-view-panel]").each(function() {
    this.hidden = this.dataset.cartViewPanel !== view;
  });
  if (view === "wishlist") {
    vsp.loadCartWishlist(swat, $scope.find("[data-cart-wishlist-display]")[0]);
  }
};
vsp.logCartWishlistView = function(scope) {
  const $destination = $(scope).find("[data-cart-wishlist-display]");
  if (!$destination.length) return;
  if ($destination.attr("data-wishlist-loaded") === "true") {
    vsp.logWishlistEvent("wishlist_view", {
      source: vsp.wishlistSource($destination),
      item_count: $destination.find(".wishlist-cart-item").length
    });
  } else {
    $destination.attr("data-log-view-on-load", "true");
  }
};
vsp.cartWishlistViews = function(swat) {
  $("body").off("click.vspCartWishlistView", "[data-cart-view-trigger]").on("click.vspCartWishlistView", "[data-cart-view-trigger]", function(event) {
    event.preventDefault();
    const scope = $(event.currentTarget).closest("[data-cart-wishlist-scope]")[0];
    const view = event.currentTarget.dataset.cartViewTrigger;
    if (view === "wishlist" && scope && scope.dataset.cartView !== "wishlist") vsp.logCartWishlistView(scope);
    vsp.setCartWishlistView(scope, view, window.swat);
  });
  $("body").off("click.vspCartWishlistInBag", "[data-cart-view-panel='wishlist'] .wishlist-display .in-cart").on("click.vspCartWishlistInBag", "[data-cart-view-panel='wishlist'] .wishlist-display .in-cart", function(event) {
    event.preventDefault();
    const scope = $(event.currentTarget).closest("[data-cart-wishlist-scope]")[0];
    vsp.setCartWishlistView(scope, "bag", window.swat);
  });
  $("[data-cart-wishlist-scope]").each(function() {
    vsp.setCartWishlistView(this, this.dataset.cartView || "bag", swat);
  });
};
vsp.wishlist = function() {
  function onSwymLoadCallback(swat) {
    window.swat = swat;
    const ownWishlistPromise = $("[data-cart-wishlist-authenticated], .wishlist-display[data-type='own']").length ? vsp.fetchWishlistProducts(swat) : null;
    if (ownWishlistPromise) ownWishlistPromise.catch(function() {
    });
    if (!vsp.wishlistCountEventsBound && swat.evtLayer) {
      vsp.wishlistCountEventsBound = true;
      swat.evtLayer.addEventListener("sw:addedtowishlist", function(event) {
        const itemData = event.detail && event.detail.d;
        if (!itemData) return;
        vsp.fetchWishlistProducts(swat).then(function() {
          vsp.addWishlistProductToCache({
            du: itemData.du,
            epi: parseInt(itemData.epi, 10),
            empi: parseInt(itemData.empi, 10)
          });
        });
      });
      swat.evtLayer.addEventListener("sw:removedfromwishlist", function(event) {
        const itemData = event.detail && event.detail.d;
        if (!itemData) return;
        vsp.removeWishlistProductFromCache({
          epi: parseInt(itemData.epi, 10),
          empi: parseInt(itemData.empi, 10)
        });
      });
    }
    if ($(".item-view").length) {
      vsp.productPageWishlist(swat);
    }
    if ($(".move-cart-item-to-wishlist").length) {
      vsp.cartWishlist(swat);
    }
    vsp.renderCartWishlistCounts(swat);
    vsp.cartWishlistViews(swat);
    if ($(".item-grid").length) {
      vsp.itemGridWishlist(swat);
    }
    if (swat) {
      $(".wishlist-display-actions .share-by-link").on("click", function(event) {
        event.preventDefault();
        swat.generateSharedListURL(
          null,
          function(data, sharedListId) {
            const url = `${window.location.origin}/pages/view-shared-wishlist?lid=${sharedListId}`;
            try {
              navigator?.clipboard?.writeText(url);
              const $link = $(event.currentTarget);
              const linkText = $link.text();
              $link.width($link.width());
              $link.text("Link Copied");
              setTimeout(function() {
                $link.text(linkText);
                $link.width("auto");
              }, 1e3);
            } catch (err) {
              alert(`unable to copy to clipboard. URL: ${url}`);
            }
          },
          function(data) {
            alert("Unable to create link to wishlist");
          }
        );
      });
      if ($(".wishlist-display[data-type='own']:not([data-cart-wishlist-display])").length) {
        ownWishlistPromise.then(function(allWishlistedProducts) {
          vsp.displayWishlist(swat, allWishlistedProducts, $(".wishlist-display[data-type='own']:not([data-cart-wishlist-display])"));
          vsp.logWishlistEvent("wishlist_view", { source: "wishlist_page", item_count: (allWishlistedProducts || []).length });
          console.log("successfully retrieved the wishlist", allWishlistedProducts);
        }).catch(function(error) {
          console.log("There was an error while fetching the wishlist", error);
        });
      } else if ($(".wishlist-display[data-type='shared']").length) {
        const queryParams = swat.utils.getEncodedAsObject(window.location.search);
        const listId = queryParams["lid"];
        if (!listId || !listId.length) {
          return alert("There was an error loading the shared wishlist");
        }
        swat.fetchListDetails({
          lid: listId
        }, function(data) {
          console.log("data,data", data);
          if (data.list.uby && data.list.userinfo) {
            $(".wishlist-description .email").text(data.list.uby);
            $(".wishlist-description .name").text(data.list.userinfo.fname + " " + data.list.userinfo.lname);
            $(".wishlist-description").show();
            const name = data.list.userinfo.fname + " " + data.list.userinfo.lname;
            console.log("NAME", name);
            if (name.trim().length) {
              let $pageTitle = $(".page-title");
              let titleTemplate = $pageTitle.attr("data-populated-text");
              let text = titleTemplate.replace("[[name]]", name);
              $pageTitle.text(text);
            }
          }
          vsp.displayWishlist(swat, data.items);
          vsp.logAnalyticsEvent("wishlist_view", { source: "shared_wishlist", item_count: (data.items || []).length });
        }, function(error, x) {
          $(".error-message").show();
          $(".wishlist-display").hide();
        });
      }
    }
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
};
vsp.cart = function() {
  vsp.renderCartWishlistCounts(window.swat);
  $("body").on("click", ".add-upsell-to-cart", function(event) {
    const $clicked = $(event.currentTarget);
    const id = parseInt($clicked.attr("data-variant-id"), 10);
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        "id": id,
        "quantity": 1
      },
      dataType: "json",
      success: function(data) {
        $clicked.width($clicked.width()).text("Added");
        setTimeout(function() {
          window.scrollTo(0, { behavior: "smooth" });
          setTimeout(function() {
            window.location.reload();
          }, 50);
        }, 50);
      },
      error: function(data) {
        alert(data.responseJSON.description);
      }
    });
  });
};
$(vsp.init);
